// Articles SEO — DP Architecture
// Daniela Parito Architecture — Montpellier, Hérault

export const articlesData = [
  {
    id: 4,
    slug: "re2020-herault-architecture-durable",
    date: "Janvier 2025",
    dateEN: "January 2025",
    dateISO: "2025-01-15",
    dateModifiedISO: "2026-08-07",
    category: "Expertise",
    categoryEN: "Expertise",
    image: "/images/projets/pierre-vives/1.webp",
    seoTitle: "RE2020 dans l'Hérault : construire durable | DP Architecture",
    seoDescription: "Comprendre la RE2020 et ses enjeux pour vos projets de construction dans l'Hérault. DP Architecture vous accompagne, de la conception au chantier.",
    seoKeywords: "RE2020 hérault, architecture durable montpellier, BBC hérault, bâtiment passif montpellier, architecte RE2020 hérault, construction durable montpellier",
    title: "La RE2020 dans l'Hérault : construire durable avec un architecte expert",
    titleEN: "RE2020 in the Hérault: building sustainably with an expert architect",
    excerpt: "La réglementation environnementale 2020 transforme profondément les pratiques architecturales. Découvrez comment DP Architecture vous accompagne dans vos projets durables dans l'Hérault.",
    excerptEN: "The 2020 environmental regulation is profoundly transforming architectural practices. Discover how DP Architecture guides you through your sustainable construction projects in the Hérault.",
    content: [
      {
        type: "paragraph",
        text: "Entrée en vigueur en janvier 2022 pour les maisons individuelles et les immeubles collectifs, la réglementation environnementale RE2020 représente une véritable révolution dans les pratiques de la construction. Dans l'Hérault, territoire soumis à un ensoleillement exceptionnel et à des enjeux énergétiques et climatiques spécifiques, cette nouvelle donne architecturale ouvre des perspectives passionnantes pour concevoir des bâtiments plus sobres, plus confortables et plus respectueux de l'environnement."
      },
      {
        type: "image",
        src: "/images/projets/pierre-vives/2.webp",
        alt: "Résidence Alfred Screve, ZAC Pierres Vives à Montpellier, conçue par DP Architecture"
      },
      {
        type: "heading",
        text: "Qu'est-ce que la RE2020 ?"
      },
      {
        type: "paragraph",
        text: "La RE2020 succède à la RT2012 en introduisant trois grands objectifs complémentaires. D'abord, la sobriété énergétique : réduire la consommation d'énergie des bâtiments neufs en renforçant l'isolation, en optimisant les équipements et en favorisant le recours aux énergies renouvelables. Ensuite, le confort d'été : garantir un niveau de confort thermique acceptable sans recourir à la climatisation active, un enjeu capital dans un département méditerranéen comme l'Hérault. Enfin, la réduction de l'empreinte carbone : prendre en compte les émissions de CO₂ générées par les matériaux de construction tout au long de leur cycle de vie, en favorisant les matières biosourcées et locales."
      },
      {
        type: "heading",
        text: "L'expertise RE2020 de DP Architecture"
      },
      {
        type: "paragraph",
        text: "Chez Daniela Parito Architecture, la démarche environnementale ne date pas de la RE2020. Depuis la création du cabinet en 2014 à Montpellier, nous concevons des projets intégrant les standards BBC (Bâtiment Basse Consommation) et, pour certains, les critères du bâtiment passif. Cette culture du durable nous a permis d'anticiper les exigences de la RE2020 et de l'intégrer naturellement dans nos processus de conception."
      },
      {
        type: "paragraph",
        text: "Dans l'Hérault, nous travaillons régulièrement avec des bureaux d'études thermiques spécialisés (DELORME, DURAND, BETSO) pour garantir la conformité RE2020 de nos projets. Cette collaboration pluridisciplinaire permet d'optimiser dès la phase de conception les orientations, les protections solaires, l'inertie thermique et les systèmes énergétiques. Chaque décision architecturale est ainsi évaluée à l'aune de ses performances énergétiques et environnementales."
      },
      {
        type: "heading",
        text: "RE2020 et logements collectifs dans l'Hérault"
      },
      {
        type: "paragraph",
        text: "Les logements collectifs représentent un domaine d'expertise majeur de DP Architecture. Nos résidences à Montpellier (ZAC Pierres Vives, ZAC Ovalie), à Mauguio, à Florensac, à Maraussan et à Maureilhan ont toutes été conçues avec une attention particulière portée aux performances énergétiques. La RE2020 renforce encore l'importance de cette approche en imposant des seuils d'émissions carbone et de consommation d'énergie primaire plus stricts."
      },
      {
        type: "paragraph",
        text: "Pour les promoteurs et bailleurs sociaux qui nous confient leurs opérations dans l'Hérault, l'expertise RE2020 de notre cabinet représente un gage de qualité et de sécurité réglementaire. Nous accompagnons nos maîtres d'ouvrage dès les études de faisabilité pour intégrer les contraintes RE2020 dans le montage financier des opérations."
      },
      {
        type: "image",
        src: "/images/projets/maisonbbc/3.webp",
        alt: "Maison individuelle en ossature bois BBC conçue par DP Architecture, accès et carport"
      },
      {
        type: "heading",
        text: "RE2020 et maisons individuelles : des solutions sur mesure"
      },
      {
        type: "paragraph",
        text: "Pour les particuliers qui souhaitent faire construire leur maison dans l'Hérault, la RE2020 peut sembler complexe. Notre rôle d'architecte est précisément de traduire ces exigences réglementaires en choix concrets, adaptés à votre projet et à votre budget. Ossature bois, isolation par l'extérieur, pompe à chaleur, ventilation double flux, brise-soleil... Autant de solutions techniques que nous sélectionnons et orchestrons pour concevoir votre maison idéale, conforme aux normes les plus exigeantes."
      },
      {
        type: "paragraph",
        text: "Notre maison individuelle en ossature bois BBC de Mondonville (Haute-Garonne) illustre parfaitement cette approche : une architecture contemporaine et chaleureuse, un confort thermique optimal toute l'année, et des performances énergétiques exemplaires. C'est ce niveau d'exigence que nous mettons au service de chaque projet de maison individuelle dans l'Hérault."
      },
      {
        type: "heading",
        text: "Confiez votre projet RE2020 dans l'Hérault à DP Architecture"
      },
      {
        type: "paragraph",
        text: "Que vous soyez promoteur, bailleur social, commune ou particulier, Daniela Parito Architecture vous accompagne dans la conception et le suivi de vos projets conformes RE2020 dans tout le département de l'Hérault. Notre cabinet, basé à Montpellier depuis 2014, intervient de Béziers à Lunel, de Sète à Lodève, avec une connaissance approfondie du territoire héraultais et de ses spécificités réglementaires et climatiques."
      }
    ],
    contentEN: [
      {
        type: "paragraph",
        text: "Having come into force in January 2022 for both single-family homes and multi-family buildings, the RE2020 environmental regulation represents a genuine revolution in construction practice. In the Hérault — a territory blessed with exceptional sunshine and facing specific energy and climate challenges — this new architectural paradigm opens fascinating opportunities to design buildings that are more resource-efficient, more comfortable and more respectful of the environment."
      },
      {
        type: "image",
        src: "/images/projets/pierre-vives/2.webp",
        alt: "Alfred Screve residence, ZAC Pierres Vives in Montpellier, designed by DP Architecture"
      },
      {
        type: "heading",
        text: "What is RE2020?"
      },
      {
        type: "paragraph",
        text: "RE2020 succeeds the RT2012 by introducing three complementary objectives. First, energy sobriety: reducing the energy consumption of new buildings by strengthening insulation, optimising systems and encouraging the use of renewable energy. Second, summer comfort: guaranteeing an acceptable level of thermal comfort without active air conditioning — a critical issue in a Mediterranean department like the Hérault. Third, reducing the carbon footprint: accounting for CO₂ emissions generated by construction materials throughout their life cycle, favouring bio-sourced and local materials."
      },
      {
        type: "heading",
        text: "DP Architecture's RE2020 expertise"
      },
      {
        type: "paragraph",
        text: "At Daniela Parito Architecture, the environmental commitment predates RE2020. Since the studio was established in Montpellier in 2014, we have designed projects incorporating BBC (Low Energy Building) standards and, for some, passive building criteria. This culture of sustainability allowed us to anticipate RE2020 requirements and integrate them naturally into our design processes."
      },
      {
        type: "paragraph",
        text: "In the Hérault, we regularly collaborate with specialist thermal engineering firms (DELORME, DURAND, BETSO) to ensure RE2020 compliance across our projects. This multidisciplinary collaboration enables us to optimise orientations, solar shading, thermal mass and energy systems from the earliest design phase. Every architectural decision is evaluated against its energy and environmental performance."
      },
      {
        type: "heading",
        text: "RE2020 and multi-family housing in the Hérault"
      },
      {
        type: "paragraph",
        text: "Multi-family housing is a major area of expertise for DP Architecture. Our residences in Montpellier (ZAC Pierres Vives, ZAC Ovalie), Mauguio, Florensac, Maraussan and Maureilhan were all designed with particular attention to energy performance. RE2020 further reinforces the importance of this approach by imposing stricter carbon emission and primary energy consumption thresholds."
      },
      {
        type: "paragraph",
        text: "For the developers and social landlords who entrust us with their projects in the Hérault, our RE2020 expertise represents a guarantee of quality and regulatory security. We work with our clients from the feasibility stage to integrate RE2020 constraints into the financial structuring of the schemes."
      },
      {
        type: "image",
        src: "/images/projets/maisonbbc/3.webp",
        alt: "BBC timber-frame single-family home designed by DP Architecture, driveway and carport"
      },
      {
        type: "heading",
        text: "RE2020 and single-family homes: bespoke solutions"
      },
      {
        type: "paragraph",
        text: "For private clients wishing to build their home in the Hérault, RE2020 can seem complex. Our role as architect is precisely to translate these regulatory requirements into concrete choices tailored to your project and budget. Timber frame, external insulation, heat pump, dual-flow ventilation, solar shading — these are among the technical solutions we select and orchestrate to design your ideal home, fully compliant with the most demanding standards."
      },
      {
        type: "paragraph",
        text: "Our BBC timber-frame home in Mondonville (Haute-Garonne) perfectly illustrates this approach: contemporary and warm architecture, optimal thermal comfort year-round, and exemplary energy performance. This level of exacting quality is what we bring to every single-family home project in the Hérault."
      },
      {
        type: "heading",
        text: "Entrust your RE2020 project in the Hérault to DP Architecture"
      },
      {
        type: "paragraph",
        text: "Whether you are a property developer, social landlord, local authority or private client, Daniela Parito Architecture will guide you through the design and supervision of your RE2020-compliant projects across the entire Hérault department. Our studio, based in Montpellier since 2014, works from Béziers to Lunel, from Sète to Lodève, with an in-depth knowledge of the Hérault territory and its specific regulatory and climatic requirements."
      }
    ]
  },
  {
    id: 5,
    slug: "logements-collectifs-montpellier-herault",
    date: "Novembre 2024",
    dateEN: "November 2024",
    dateISO: "2024-11-10",
    dateModifiedISO: "2026-08-07",
    category: "Réalisations",
    categoryEN: "Projects",
    image: "/images/projets/ovalie/1.webp",
    seoTitle: "Logements collectifs à Montpellier | DP Architecture",
    seoDescription: "DP Architecture conçoit des logements collectifs à Montpellier et dans l'Hérault : ZAC Ovalie, Pierres Vives, Mauguio, Florensac. Découvrez nos réalisations.",
    seoKeywords: "logements collectifs montpellier, logement collectif hérault, résidence montpellier, architecte logement collectif, ZAC montpellier, promoteur logement herault",
    title: "Logements collectifs à Montpellier et dans l'Hérault",
    titleEN: "Multi-family housing in Montpellier and the Hérault",
    excerpt: "DP Architecture est un acteur reconnu de la construction de logements collectifs dans l'Hérault. Retour sur 30 ans de réalisations entre Montpellier, Mauguio, Florensac et l'agglomération héraultaise.",
    excerptEN: "DP Architecture is a recognised specialist in multi-family housing construction in the Hérault. A look back at 30 years of achievements across Montpellier, Mauguio, Florensac and the wider Hérault area.",
    content: [
      {
        type: "paragraph",
        text: "La construction de logements collectifs dans l'Hérault est au cœur de l'activité de Daniela Parito Architecture depuis la création du cabinet en 2014. Avec 30 ans d'expérience cumulée — dont 24 ans dans de grandes agences parisiennes et régionales avant l'installation à Montpellier — Daniela Parito Sorrenti maîtrise l'ensemble des enjeux complexes liés à la conception et à la réalisation de résidences collectives : montage réglementaire, faisabilité technique, performance énergétique, intégration urbaine et qualité de vie des futurs résidents."
      },
      {
        type: "heading",
        text: "Un ancrage fort dans l'agglomération montpelliéraine"
      },
      {
        type: "paragraph",
        text: "Montpellier, métropole en pleine croissance démographique, génère une demande soutenue en logements neufs. DP Architecture y a réalisé deux opérations de référence. La résidence Alfred Screve, livrée dans le cadre de la ZAC Pierres Vives, quartier culturel et résidentiel innovant au nord de Montpellier. Et la résidence Park View au sein de la ZAC Ovalie, 32 logements en accession libre qui ont fait l'objet d'une couverture presse notable à leur livraison en 2019."
      },
      {
        type: "paragraph",
        text: "Ces deux opérations illustrent notre capacité à intervenir dans des zones d'aménagement concertées complexes, avec leurs exigences réglementaires spécifiques (Plan de Zone, cahier des charges de la ZAC, coordination avec le maître d'ouvrage urbain) et leurs enjeux architecturaux forts : insertion dans un quartier en devenir, dialogue avec les architectes des bâtiments voisins, composition de façades qui s'inscrivent dans une cohérence d'ensemble."
      },
      {
        type: "image",
        src: "/images/projets/patioclement/1.webp",
        alt: "Résidence Patio Clément à Mauguio, 34 logements conçus par DP Architecture"
      },
      {
        type: "heading",
        text: "Des réalisations dans tout le département de l'Hérault"
      },
      {
        type: "paragraph",
        text: "Au-delà de la métropole montpelliéraine, DP Architecture a conduit des opérations de logements collectifs dans plusieurs communes héraultaises. À Mauguio, la résidence Pélissier et la résidence Patio Clément témoignent de notre présence récurrente dans cette commune périurbaine dynamique. À Florensac, la résidence Cité Marcadal s'inscrit dans le tissu urbain de cette ville viticole du Bassin de Thau. À Maraussan, la résidence Les Semailles apporte une réponse architecturale de qualité à un village en développement du Biterrois. À Maureilhan, la résidence La Vigneronne poursuit cette implantation dans le vignoble héraultais."
      },
      {
        type: "paragraph",
        text: "Cette diversité géographique témoigne de notre capacité à adapter notre approche architecturale aux contextes très différents que propose l'Hérault : tissu urbain dense montpelliérain, communes périurbaines en expansion, villages à identité patrimoniale forte dans l'arrière-pays..."
      },
      {
        type: "image",
        src: "/images/projets/pelissier/1.webp",
        alt: "Résidence Pélissier à Mauguio, logements collectifs signés DP Architecture"
      },
      {
        type: "heading",
        text: "Notre approche du logement collectif"
      },
      {
        type: "paragraph",
        text: "Concevoir un logement collectif, c'est avant tout imaginer des espaces de vie de qualité pour des familles et des individus aux besoins divers. Notre philosophie s'articule autour de quelques principes fondamentaux. L'orientation et la lumière naturelle d'abord : chaque logement bénéficie d'un ensoleillement optimal, avec des protections solaires adaptées au climat méditerranéen. La qualité des espaces extérieurs privatifs (balcons, loggias, terrasses) qui constituent un prolongement essentiel du logement. L'intégration paysagère et urbaine pour que chaque résidence s'inscrive harmonieusement dans son environnement bâti et naturel."
      },
      {
        type: "paragraph",
        text: "Sur le plan technique, nous concevons des bâtiments conformes aux normes RE2020 et BBC, en collaboration avec des bureaux d'études thermiques et fluides reconnus. La maîtrise des coûts est également un engagement central : nous respectons strictement les enveloppes budgétaires définies avec nos maîtres d'ouvrage."
      },
      {
        type: "heading",
        text: "Confiez votre opération de logements collectifs dans l'Hérault à DP Architecture"
      },
      {
        type: "paragraph",
        text: "Promoteurs immobiliers, bailleurs sociaux, collectivités locales : Daniela Parito Architecture est votre partenaire de confiance pour la conception et la réalisation de logements collectifs dans l'Hérault. De la faisabilité au dépôt de permis de construire, du suivi de chantier à la livraison, nous vous accompagnons à chaque étape de votre projet. Contactez-nous pour une première consultation."
      }
    ],
    contentEN: [
      {
        type: "paragraph",
        text: "Multi-family housing construction in the Hérault has been at the core of Daniela Parito Architecture's activity since the studio was founded in 2014. With 30 years of cumulative experience — including 24 years in major Parisian and regional agencies before settling in Montpellier — Daniela Parito Sorrenti masters all the complex challenges involved in designing and delivering residential buildings: regulatory assembly, technical feasibility, energy performance, urban integration and quality of life for future residents."
      },
      {
        type: "heading",
        text: "A strong foothold in the Montpellier agglomeration"
      },
      {
        type: "paragraph",
        text: "Montpellier, a metropolis experiencing strong demographic growth, generates sustained demand for new housing. DP Architecture has completed two benchmark schemes here. The Alfred Screve residence, delivered within the ZAC Pierres Vives, an innovative cultural and residential district in northern Montpellier. And the Park View residence within the ZAC Ovalie — 32 owner-occupied apartments that received notable press coverage at their delivery in 2019."
      },
      {
        type: "paragraph",
        text: "These two schemes demonstrate our ability to work within complex urban development zones, with their specific regulatory requirements (Zone Plan, ZAC specifications, coordination with the urban client) and their strong architectural challenges: integration into an emerging district, dialogue with the architects of neighbouring buildings, and façade design that contributes to overall coherence."
      },
      {
        type: "image",
        src: "/images/projets/patioclement/1.webp",
        alt: "Patio Clément residence in Mauguio, 34 homes designed by DP Architecture"
      },
      {
        type: "heading",
        text: "Projects across the entire Hérault department"
      },
      {
        type: "paragraph",
        text: "Beyond the Montpellier metropolis, DP Architecture has led multi-family housing schemes in several Hérault communes. In Mauguio, the Pélissier residence and the Patio Clément residence reflect our recurring presence in this dynamic peri-urban commune. In Florensac, the Cité Marcadal residence is embedded in the urban fabric of this wine-growing town on the Bassin de Thau. In Maraussan, the Les Semailles residence delivers a quality architectural response to a developing village near Béziers. In Maureilhan, the La Vigneronne residence continues this presence in the Hérault vineyards."
      },
      {
        type: "paragraph",
        text: "This geographical diversity reflects our ability to adapt our architectural approach to the very different contexts the Hérault has to offer: dense Montpellier urban fabric, expanding peri-urban communes, heritage villages in the hinterland..."
      },
      {
        type: "image",
        src: "/images/projets/pelissier/1.webp",
        alt: "Pélissier residence in Mauguio, multi-family housing by DP Architecture"
      },
      {
        type: "heading",
        text: "Our approach to multi-family housing"
      },
      {
        type: "paragraph",
        text: "Designing multi-family housing is above all about imagining quality living spaces for families and individuals with diverse needs. Our philosophy is built around a few fundamental principles. Orientation and natural light first: every apartment benefits from optimum sunlight, with solar shading adapted to the Mediterranean climate. The quality of private outdoor spaces (balconies, loggias, terraces) which are an essential extension of the home. Landscape and urban integration so that each residence fits harmoniously into its built and natural environment."
      },
      {
        type: "paragraph",
        text: "On the technical side, we design buildings that comply with RE2020 and BBC standards, in collaboration with recognised thermal and services engineering firms. Cost management is also a central commitment: we strictly adhere to the budget envelopes agreed with our clients."
      },
      {
        type: "heading",
        text: "Entrust your multi-family housing project in the Hérault to DP Architecture"
      },
      {
        type: "paragraph",
        text: "Property developers, social landlords, local authorities: Daniela Parito Architecture is your trusted partner for the design and delivery of multi-family housing in the Hérault. From feasibility to planning submission, from site supervision to handover, we support you at every stage of your project. Contact us for an initial consultation."
      }
    ]
  },
  {
    id: 6,
    slug: "maison-individuelle-herault-architecte-dplg",
    date: "Septembre 2024",
    dateEN: "September 2024",
    dateISO: "2024-09-05",
    dateModifiedISO: "2026-08-07",
    category: "Conseils",
    categoryEN: "Advice",
    image: "/images/projets/maisonbbc/1.webp",
    seoTitle: "Architecte maison individuelle Hérault | DP Architecture",
    seoDescription: "Faire construire sa maison individuelle dans l'Hérault avec Daniela Parito, architecte : conception sur mesure, BBC, ossature bois. Premier échange gratuit.",
    seoKeywords: "maison individuelle hérault, architecte maison herault, construire maison montpellier, architecte maison individuelle, maison BBC herault, villa contemporaine montpellier",
    title: "Construire sa maison individuelle dans l'Hérault avec un architecte",
    titleEN: "Building your home in the Hérault with an architect",
    excerpt: "Faire appel à un architecte pour votre maison individuelle dans l'Hérault, c'est choisir un accompagnement sur mesure, une garantie de qualité et une expertise en architecture méditerranéenne contemporaine.",
    excerptEN: "Choosing an architect for your single-family home in the Hérault means opting for a bespoke service, a guarantee of quality and expertise in contemporary Mediterranean architecture.",
    content: [
      {
        type: "paragraph",
        text: "Dans l'Hérault, la construction d'une maison individuelle est une aventure humaine et architecturale unique. Face à la diversité des terrains — de la plaine montpelliéraine aux garrigues de l'arrière-pays, en passant par le littoral méditerranéen — chaque projet de maison exige une approche sur mesure, ancrée dans le contexte local et adaptée aux aspirations des futurs habitants. C'est précisément le rôle d'un architecte comme Daniela Parito Sorrenti."
      },
      {
        type: "heading",
        text: "Pourquoi faire appel à un architecte pour votre maison ?"
      },
      {
        type: "paragraph",
        text: "L'architecte inscrit à l'Ordre des architectes possède une formation de haut niveau en conception architecturale, en réglementation de la construction et en gestion de projet. Contrairement à d'autres intervenants du bâtiment, l'architecte a le devoir de défendre vos intérêts tout au long du projet : il conçoit votre maison en tenant compte de vos besoins, de votre budget et de vos contraintes, puis coordonne les entreprises pendant les travaux pour garantir la qualité de la réalisation."
      },
      {
        type: "paragraph",
        text: "Pour les constructions dont le plancher dépassera 150 m², le recours à un architecte est d'ailleurs obligatoire en France. Mais même pour les projets plus modestes, l'architecte apporte une valeur ajoutée déterminante en termes de qualité architecturale, de performance énergétique et de valorisation patrimoniale de votre bien."
      },
      {
        type: "image",
        src: "/images/projets/maisonbaillargue/4.webp",
        alt: "Maison individuelle contemporaine à Baillargues dans l'Hérault : terrasse, piscine et toiture végétalisée"
      },
      {
        type: "heading",
        text: "L'expertise de DP Architecture en maisons individuelles"
      },
      {
        type: "paragraph",
        text: "Daniela Parito Architecture conçoit des maisons individuelles dans l'Hérault et plus largement en Occitanie. Deux d'entre elles font partie de notre portfolio de référence. La maison individuelle de Baillargues, dans l'Hérault, illustre notre capacité à concevoir une architecture contemporaine bien intégrée dans un tissu péri-urbain. La maison individuelle en ossature bois BBC de Mondonville, en Haute-Garonne, est quant à elle un manifeste de notre engagement pour l'architecture écologique : construction en bois local, isolation renforcée, performances BBC avérées, confort thermique remarquable été comme hiver."
      },
      {
        type: "paragraph",
        text: "Ces réalisations traduisent notre philosophie : une architecture forte, intentionnelle et sensible, mais jamais excessive. Des espaces de vie de qualité, pensés pour le confort et le bien-être des habitants, toujours en dialogue avec le contexte naturel et bâti environnant."
      },
      {
        type: "heading",
        text: "Architecture méditerranéenne et performance énergétique"
      },
      {
        type: "paragraph",
        text: "Dans l'Hérault, le climat méditerranéen impose des contraintes et offre des opportunités que tout architecte local doit maîtriser. Les étés chauds exigent des protections solaires efficaces (brise-soleil, débords de toiture, végétation), une inertie thermique adaptée et des dispositifs de ventilation naturelle. Les hivers doux permettent en revanche de concevoir des espaces ouverts sur l'extérieur, avec de larges baies vitrées orientées au sud pour capter la chaleur du soleil."
      },
      {
        type: "paragraph",
        text: "La nouvelle réglementation RE2020, appliquée depuis 2022, renforce encore l'importance de cette approche bioclimatique. Elle introduit notamment un critère de confort d'été (DH — Degrés-Heures d'inconfort) qui oblige à concevoir des maisons naturellement fraîches sans recourir à la climatisation active. DP Architecture maîtrise parfaitement ces exigences et les intègre dès les premières esquisses de votre projet."
      },
      {
        type: "image",
        src: "/images/projets/maisonbaillargue/5.webp",
        alt: "Implantation d'une maison individuelle dans l'Hérault : accès, garage et intégration à la parcelle"
      },
      {
        type: "heading",
        text: "De l'esquisse à la livraison : notre accompagnement complet"
      },
      {
        type: "paragraph",
        text: "Notre accompagnement pour votre maison individuelle dans l'Hérault couvre l'intégralité des étapes du projet. Lors de la phase études, nous analysons votre terrain (orientation, topographie, vues, servitudes), nous étudions les règles d'urbanisme (PLU, PPRI, secteurs ABF) et nous esquissons plusieurs pistes architecturales qui répondent à votre programme et à vos aspirations. Après validation de l'esquisse préférée, nous développons l'avant-projet sommaire puis l'avant-projet définitif, jusqu'au dépôt du permis de construire."
      },
      {
        type: "paragraph",
        text: "Pendant la phase chantier, nous consultons les entreprises, analysons les devis, et assurons le suivi régulier du chantier pour contrôler la qualité d'exécution, le respect du planning et la maîtrise des coûts. À la livraison, nous vous accompagnons lors de la réception des travaux, avec vérification de la conformité de chaque ouvrage au projet."
      },
      {
        type: "heading",
        text: "Construire votre maison dans l'Hérault avec DP Architecture"
      },
      {
        type: "paragraph",
        text: "Daniela Parito Architecture intervient pour des projets de maisons individuelles dans tout le département de l'Hérault : Montpellier et son agglomération (Baillargues, Castelnau-le-Lez, Juvignac, Lattes, Saint-Jean-de-Védas, Mauguio), le littoral (Sète, Agde, Frontignan), et les villes et villages de l'intérieur (Béziers, Pézenas, Clermont-l'Hérault, Lodève). Contactez-nous pour discuter de votre projet : première consultation gratuite et sans engagement."
      }
    ],
    contentEN: [
      {
        type: "paragraph",
        text: "In the Hérault, building a single-family home is a unique human and architectural adventure. Given the diversity of sites — from the Montpellier plain to the garrigue scrubland of the hinterland and the Mediterranean coast — every home project demands a bespoke approach, rooted in the local context and adapted to the aspirations of the future occupants. This is precisely the role of an architect such as Daniela Parito Sorrenti."
      },
      {
        type: "heading",
        text: "Why use an architect for your home?"
      },
      {
        type: "paragraph",
        text: "An architect registered with the French Ordre des Architectes has a high level of training in architectural design, construction regulations and project management. Unlike other construction professionals, the architect has a duty to defend your interests throughout the project: designing your home to meet your needs, budget and constraints, then coordinating contractors during the works to guarantee the quality of the final result."
      },
      {
        type: "paragraph",
        text: "For buildings with a floor area exceeding 150 m², using an architect is in fact mandatory in France. But even for smaller projects, the architect adds decisive value in terms of architectural quality, energy performance and the long-term asset value of your property."
      },
      {
        type: "image",
        src: "/images/projets/maisonbaillargue/4.webp",
        alt: "Contemporary single-family home in Baillargues, Hérault: terrace, pool and green roof"
      },
      {
        type: "heading",
        text: "DP Architecture's expertise in single-family homes"
      },
      {
        type: "paragraph",
        text: "Daniela Parito Architecture designs single-family homes across the Hérault and the wider Occitanie region. Two of them are part of our reference portfolio. The home in Baillargues, in the Hérault, illustrates our ability to design contemporary architecture that is well integrated into a peri-urban fabric. The BBC timber-frame home in Mondonville, in the Haute-Garonne, is a manifesto of our commitment to ecological architecture: locally sourced timber construction, enhanced insulation, proven BBC performance, and remarkable thermal comfort in both summer and winter."
      },
      {
        type: "paragraph",
        text: "These projects reflect our philosophy: bold, intentional and sensitive architecture — but never excessive. Quality living spaces designed for the comfort and wellbeing of the occupants, always in dialogue with the surrounding natural and built context."
      },
      {
        type: "heading",
        text: "Mediterranean architecture and energy performance"
      },
      {
        type: "paragraph",
        text: "In the Hérault, the Mediterranean climate imposes constraints and offers opportunities that every local architect must master. Hot summers demand effective solar shading (brise-soleil, roof overhangs, vegetation), appropriate thermal mass and natural ventilation systems. Mild winters, on the other hand, allow for spaces that open onto the outside, with large glazed openings facing south to capture solar warmth."
      },
      {
        type: "paragraph",
        text: "The new RE2020 regulation, in force since 2022, further reinforces the importance of this bioclimatic approach. It introduces a summer comfort criterion (DH — Degree-Hours of discomfort) that requires homes to be naturally cool without resorting to active air conditioning. DP Architecture fully masters these requirements and integrates them from the very first sketches of your project."
      },
      {
        type: "image",
        src: "/images/projets/maisonbaillargue/5.webp",
        alt: "Site layout of a single-family home in the Hérault: access, garage and integration into the plot"
      },
      {
        type: "heading",
        text: "From sketch to handover: our complete support"
      },
      {
        type: "paragraph",
        text: "Our support for your single-family home in the Hérault covers every stage of the project. During the design phase, we analyse your plot (orientation, topography, views, easements), study the planning rules (PLU, PPRI, ABF zones) and sketch several architectural options that respond to your brief and aspirations. Once the preferred scheme is validated, we develop the preliminary design and then the detailed design, through to the submission of the planning application."
      },
      {
        type: "paragraph",
        text: "During the construction phase, we consult contractors, review quotations and carry out regular site visits to monitor execution quality, programme compliance and cost management. At handover, we accompany you during the final acceptance of the works, checking that every element conforms to the project."
      },
      {
        type: "heading",
        text: "Build your home in the Hérault with DP Architecture"
      },
      {
        type: "paragraph",
        text: "Daniela Parito Architecture works on single-family home projects across the entire Hérault department: Montpellier and its agglomeration (Baillargues, Castelnau-le-Lez, Juvignac, Lattes, Saint-Jean-de-Védas, Mauguio), the coast (Sète, Agde, Frontignan), and the inland towns and villages (Béziers, Pézenas, Clermont-l'Hérault, Lodève). Contact us to discuss your project: free initial consultation, no commitment."
      }
    ]
  },
  {
    "id": 7,
    "slug": "zan-zero-artificialisation-nette-herault",
    "date": "Mai 2026",
    "dateEN": "May 2026",
    "dateISO": "2026-05-20",
    "category": "Urbanisme",
    "categoryEN": "Urban Planning",
    "image": "/images/projets/cambaceres/1.webp",
    "seoTitle": "ZAN dans l'Hérault : construire autrement | DP Architecture",
    "seoDescription": "Le ZAN change la façon de bâtir dans l'Hérault. Densification, réhabilitation, renouvellement urbain à Montpellier : ce que DP Architecture met en oeuvre.",
    "seoKeywords": "ZAN Hérault, zéro artificialisation nette Montpellier, densification urbaine Hérault, renouvellement urbain Montpellier, réhabilitation bâti existant Hérault, construire dans l'Hérault foncier rare, architecte logements collectifs Montpellier, surélévation immeuble Occitanie",
    "title": "ZAN dans l'Hérault : comment bâtir quand le foncier se raréfie",
    "titleEN": "ZAN in the Hérault: how to build when land becomes scarce",
    "excerpt": "Le Zéro Artificialisation Nette redessine la construction dans l'Hérault. Moins de foncier en extension, priorité au renouvellement urbain et à la réhabilitation : voici ce que cela change concrètement pour vos projets, et le rôle de l'architecte pour bâtir dense et qualitatif.",
    "excerptEN": "Zero Net Land Take is reshaping construction in the Hérault. Less land for urban extension, priority to urban renewal and rehabilitation: here is what it concretely changes for your projects, and the architect's role in building dense and high-quality.",
    "content": [
      {
        "type": "paragraph",
        "text": "Le foncier devient rare dans l'Hérault. La croissance démographique de l'aire montpelliéraine est forte, mais la réglementation limite désormais l'étalement urbain. Au centre de ce changement : le ZAN, le Zéro Artificialisation Nette. Ce cadre transforme la manière de concevoir un projet, qu'il s'agisse de logements collectifs, d'une maison ou d'un équipement public."
      },
      {
        "type": "paragraph",
        "text": "Comprendre le ZAN n'est pas qu'un sujet d'urbaniste. C'est une donnée concrète qui influence votre terrain, votre permis et la valeur de votre opération. Voici l'essentiel, présenté simplement, avec ce que cela implique pour bâtir dans le département."
      },
      {
        "type": "heading",
        "text": "Le ZAN, qu'est-ce que c'est exactement ?"
      },
      {
        "type": "paragraph",
        "text": "Le ZAN est un objectif issu de la loi Climat et Résilience de 2021. Il vise le zéro artificialisation nette des sols d'ici 2050. En clair : à cette échéance, chaque hectare nouvellement urbanisé devrait être compensé par un hectare renaturé. L'artificialisation désigne le fait de transformer un sol naturel ou agricole en surface bâtie, imperméabilisée ou aménagée."
      },
      {
        "type": "paragraph",
        "text": "Un jalon intermédiaire accompagne cet horizon : réduire de 50 % le rythme d'artificialisation sur la période 2021-2031, par rapport à la décennie précédente. L'idée centrale est de préserver les terres agricoles et naturelles, ressources non renouvelables, tout en continuant à loger une population qui augmente."
      },
      {
        "type": "heading",
        "text": "Où en est le cadre réglementaire en 2026 ?"
      },
      {
        "type": "paragraph",
        "text": "Le dispositif est en pleine évolution, et nous l'abordons avec prudence. Une proposition de loi TRACE, pour Trajectoire de Réduction de l'Artificialisation Concertée avec les Élus locaux, a été adoptée par le Sénat en mars 2025. Elle est en attente d'examen à l'Assemblée nationale en 2026."
      },
      {
        "type": "paragraph",
        "text": "Cette proposition assouplirait le dispositif : le jalon intermédiaire passerait de 2031 à 2034, les objectifs seraient fixés par les régions, et les communes pourraient ouvrir à l'urbanisation jusqu'à 20 % de leur enveloppe foncière. En avril 2026, des assouplissements supplémentaires ont par ailleurs été introduits via une loi de simplification économique, avec des exemptions additionnelles."
      },
      {
        "type": "paragraph",
        "text": "À retenir : le cadre exact reste en débat en 2026 et pourrait encore bouger. Mais la trajectoire de long terme vers le ZAN 2050 demeure. Pour vos projets, mieux vaut anticiper dès maintenant une logique de sobriété foncière plutôt que de miser sur un retour à l'extension facile."
      },
      {
        "type": "image",
        "src": "/images/projets/macrolotA/1.webp",
        "alt": "Macrolot de logements collectifs conçu par DP Architecture dans une ZAC de Montpellier, exemple de densification maîtrisée dans l'Hérault"
      },
      {
        "type": "heading",
        "text": "Ce que le ZAN change concrètement pour construire dans l'Hérault"
      },
      {
        "type": "paragraph",
        "text": "La conséquence est directe : moins de foncier disponible en extension, et donc une priorité donnée au foncier déjà urbanisé. Construire ne disparaît pas, mais les règles du jeu se déplacent. On bâtit désormais davantage dans la ville existante que sur ses marges."
      },
      {
        "type": "paragraph",
        "text": "Quatre leviers deviennent centraux. Le renouvellement urbain, qui consiste à recomposer des quartiers ou des friches déjà artificialisés. La densification maîtrisée, pour loger plus sans étaler. La réhabilitation du bâti existant, qui évite de consommer un nouveau terrain. Et la surélévation, qui exploite la hauteur disponible au-dessus des constructions actuelles."
      },
      {
        "type": "paragraph",
        "text": "Dans une aire montpelliéraine en forte croissance, ces leviers ne sont pas une contrainte abstraite. Ils répondent à un besoin réel de logements, tout en préservant les espaces agricoles et naturels qui font la qualité de vie du département."
      },
      {
        "type": "heading",
        "text": "Densifier sans sacrifier la qualité : le coeur du métier"
      },
      {
        "type": "paragraph",
        "text": "Densifier ne signifie pas entasser. Tout l'enjeu est de concevoir des projets denses qui restent agréables à vivre : lumière naturelle, ventilation, intimité préservée, espaces extérieurs, qualité des vues. Sur un terrain rare, chaque mètre compte, et la conception fait la différence entre une opération réussie et un projet subi."
      },
      {
        "type": "paragraph",
        "text": "C'est précisément le travail de l'architecte. Implanter intelligemment, optimiser les volumes, soigner les transitions entre privé et collectif, intégrer les normes RE2020 et les exigences de performance énergétique dès l'esquisse. Un projet bien pensé en amont coûte moins cher à construire et se valorise mieux dans le temps."
      },
      {
        "type": "image",
        "src": "/images/projets/ilot/1.webp",
        "alt": "Îlot résidentiel réalisé par DP Architecture dans l'Hérault, illustrant le renouvellement urbain et la densification qualitative"
      },
      {
        "type": "heading",
        "text": "L'expérience de DP Architecture sur le terrain"
      },
      {
        "type": "paragraph",
        "text": "Le cabinet intervient depuis plusieurs années sur des opérations qui s'inscrivent exactement dans cette logique. Au sein de la ZAC Pierres Vives à Montpellier, avec la résidence Alfred Screve. Dans la ZAC Ovalie, avec la résidence Park View, 32 logements en accession livrés en 2019. Dans la ZAC Cambacérès également, autre quartier en construction sur du foncier maîtrisé."
      },
      {
        "type": "paragraph",
        "text": "Ces ZAC sont des secteurs où l'on bâtit de la ville sur de la ville, avec une densité programmée et des exigences de qualité élevées. L'expertise du cabinet en logements collectifs, doublée d'une maîtrise des normes RE2020, BBC et bâtiment passif, permet de répondre à ces opérations là où le foncier est compté et la réglementation exigeante."
      },
      {
        "type": "heading",
        "text": "Anticiper le ZAN, c'est sécuriser votre projet"
      },
      {
        "type": "paragraph",
        "text": "Le ZAN n'est pas un frein à construire dans l'Hérault : c'est une invitation à mieux construire. Densification maîtrisée, réhabilitation, surélévation et renouvellement urbain ouvrent de réelles possibilités, à condition d'être pensées dès le départ par un architecte qui connaît le territoire et ses règles."
      },
      {
        "type": "paragraph",
        "text": "Si vous portez un projet de logements, de maison ou d'équipement dans l'Hérault, l'analyse du foncier et du potentiel constructible est l'étape déterminante. Daniela Parito Sorrenti et son cabinet vous accompagnent pour transformer ces contraintes en projets durables, qualitatifs et adaptés à votre terrain."
      }
    ],
    "contentEN": [
      {
        "type": "paragraph",
        "text": "Land is becoming scarce in the Hérault. Population growth around Montpellier is strong, yet regulation now limits urban sprawl. At the heart of this shift lies the ZAN, France's Zero Net Land Take policy. This framework is transforming the way projects are designed, whether for collective housing, a private home or a public facility."
      },
      {
        "type": "paragraph",
        "text": "Understanding the ZAN is not just a matter for urban planners. It is a concrete factor that affects your plot, your building permit and the value of your operation. Here is what matters, explained simply, along with what it means for building in the department."
      },
      {
        "type": "heading",
        "text": "What exactly is the ZAN?"
      },
      {
        "type": "paragraph",
        "text": "The ZAN is an objective set by the 2021 Climate and Resilience Act. It aims for zero net land take by 2050. In plain terms: by that date, every newly urbanised hectare should be offset by a hectare returned to nature. Land take refers to converting natural or agricultural soil into built, sealed or developed surfaces."
      },
      {
        "type": "paragraph",
        "text": "An intermediate milestone supports this horizon: cutting the pace of land take by 50% over 2021-2031, compared with the previous decade. The core idea is to preserve agricultural and natural land, which are non-renewable resources, while continuing to house a growing population."
      },
      {
        "type": "heading",
        "text": "Where does the regulatory framework stand in 2026?"
      },
      {
        "type": "paragraph",
        "text": "The system is evolving fast, and we approach it with caution. A bill known as TRACE, standing for Trajectory for Reducing Land Take in Consultation with Local Elected Officials, was passed by the Senate in March 2025. It is awaiting review by the National Assembly in 2026."
      },
      {
        "type": "paragraph",
        "text": "This bill would relax the framework: the intermediate milestone would move from 2031 to 2034, objectives would be set by the regions, and municipalities could open up to 20% of their land envelope to urbanisation. In April 2026, further relaxations were also introduced through an economic simplification act, with additional exemptions."
      },
      {
        "type": "paragraph",
        "text": "The key point: the exact framework remains under debate in 2026 and may still change. But the long-term trajectory towards ZAN 2050 stands. For your projects, it is wiser to anticipate a logic of land sobriety now rather than count on an easy return to urban extension."
      },
      {
        "type": "image",
        "src": "/images/projets/macrolotA/1.webp",
        "alt": "Collective housing macro-block designed by DP Architecture in a Montpellier development zone, an example of controlled densification in the Hérault"
      },
      {
        "type": "heading",
        "text": "What the ZAN concretely changes for building in the Hérault"
      },
      {
        "type": "paragraph",
        "text": "The consequence is direct: less land available for extension, and therefore priority given to already-urbanised land. Building does not disappear, but the rules shift. Construction now happens more within the existing city than on its edges."
      },
      {
        "type": "paragraph",
        "text": "Four levers become central. Urban renewal, which recomposes neighbourhoods or wasteland already taken. Controlled densification, to house more without spreading out. Rehabilitation of existing buildings, which avoids consuming new land. And adding storeys, which uses the available height above current structures."
      },
      {
        "type": "paragraph",
        "text": "In a fast-growing Montpellier area, these levers are not an abstract constraint. They meet a real housing need while preserving the agricultural and natural spaces that make the department a good place to live."
      },
      {
        "type": "heading",
        "text": "Densifying without sacrificing quality: the core of the craft"
      },
      {
        "type": "paragraph",
        "text": "Densifying does not mean cramming. The whole challenge is to design dense projects that remain pleasant to live in: natural light, ventilation, preserved privacy, outdoor spaces, quality of views. On a scarce plot, every square metre counts, and design makes the difference between a successful operation and a compromised one."
      },
      {
        "type": "paragraph",
        "text": "This is precisely the architect's work. Positioning the building intelligently, optimising volumes, refining the transitions between private and shared spaces, and integrating RE2020 standards and energy performance requirements from the very first sketch. A project thought through early costs less to build and holds its value better over time."
      },
      {
        "type": "image",
        "src": "/images/projets/ilot/1.webp",
        "alt": "Residential block built by DP Architecture in the Hérault, illustrating urban renewal and high-quality densification"
      },
      {
        "type": "heading",
        "text": "DP Architecture's experience on the ground"
      },
      {
        "type": "paragraph",
        "text": "The practice has been working for several years on operations that fit exactly this logic. Within the Pierres Vives development zone in Montpellier, with the Alfred Screve residence. In the Ovalie zone, with the Park View residence, 32 owner-occupied homes delivered in 2019. In the Cambacérès zone as well, another district built on controlled land."
      },
      {
        "type": "paragraph",
        "text": "These development zones are areas where city is built upon city, with planned density and high quality requirements. The practice's expertise in collective housing, combined with command of RE2020, BBC and passive building standards, makes it possible to deliver such operations where land is limited and regulation demanding."
      },
      {
        "type": "heading",
        "text": "Anticipating the ZAN means securing your project"
      },
      {
        "type": "paragraph",
        "text": "The ZAN is not a barrier to building in the Hérault: it is an invitation to build better. Controlled densification, rehabilitation, added storeys and urban renewal open up real possibilities, provided they are considered from the outset by an architect who knows the territory and its rules."
      },
      {
        "type": "paragraph",
        "text": "If you are planning a housing, home or facility project in the Hérault, analysing the land and its building potential is the decisive step. Daniela Parito Sorrenti and her practice support you in turning these constraints into durable, high-quality projects suited to your plot."
      }
    ]
  },
  {
    "id": 8,
    "slug": "architecture-bioclimatique-mediterraneenne-herault",
    "date": "Avril 2026",
    "dateEN": "April 2026",
    "dateISO": "2026-04-15",
    "dateModifiedISO": "2026-08-07",
    "category": "Expertise",
    "categoryEN": "Expertise",
    "image": "/images/projets/martinet/1.webp",
    "seoTitle": "Architecture bioclimatique méditerranéenne | DP Architecture",
    "seoDescription": "Construire frais sans climatisation dans l'Hérault : conception bioclimatique méditerranéenne et confort d'été RE2020 par DP Architecture, Montpellier.",
    "seoKeywords": "architecture bioclimatique méditerranéenne, confort d'été Hérault, construire sans climatisation Montpellier, maison fraîche Hérault, conception bioclimatique RE2020, architecte bioclimatique Hérault, degrés-heures inconfort RE2020, maison passive Occitanie",
    "title": "Architecture bioclimatique : rester au frais dans l'Hérault",
    "titleEN": "Bioclimatic architecture: staying cool in the Hérault",
    "excerpt": "Dans l'Hérault, en zone climatique H3, l'été met les logements à l'épreuve. La conception bioclimatique méditerranéenne permet de garder une maison fraîche sans climatisation, tout en répondant aux seuils de confort d'été de la RE2020. DP Architecture vous explique les leviers concrets.",
    "excerptEN": "In the Hérault, located in climate zone H3, summer puts homes to the test. Mediterranean bioclimatic design keeps a house cool without air conditioning while meeting the RE2020 summer comfort thresholds. DP Architecture walks you through the concrete levers.",
    "content": [
      {
        "type": "paragraph",
        "text": "Dans l'Hérault, l'été n'est plus une saison anodine. Le département se situe en zone climatique H3, la zone méditerranéenne, la plus exposée à la chaleur estivale du pays. Les canicules y deviennent plus fréquentes, plus longues et plus intenses. La question n'est donc plus de savoir si votre logement aura chaud, mais de savoir comment il restera vivable sans transformer la climatisation en réflexe permanent."
      },
      {
        "type": "paragraph",
        "text": "La bonne nouvelle : on sait concevoir des bâtiments qui restent frais en été par le dessin même de l'architecture, et non par une machine que l'on rajoute après coup. C'est tout l'objet de l'architecture bioclimatique méditerranéenne. Chez DP Architecture, à Montpellier, c'est une manière de concevoir maisons individuelles et logements collectifs depuis l'origine du projet."
      },
      {
        "type": "heading",
        "text": "Le confort d'été, désormais inscrit dans la réglementation"
      },
      {
        "type": "paragraph",
        "text": "Entrée en vigueur en 2022, la RE2020 ne se limite plus à l'hiver et au chauffage. Elle introduit un indicateur dédié au confort d'été : les Degrés-Heures d'inconfort, ou DH, exprimés en °C.h. Concrètement, cet indicateur mesure le temps pendant lequel, et l'intensité avec laquelle, la température intérieure dépasse un seuil de confort sur l'ensemble de la saison chaude."
      },
      {
        "type": "paragraph",
        "text": "Les repères sont clairs. En dessous de 350 °C.h, le logement est considéré comme confortable en été sans recours à la climatisation. Le plafond réglementaire maximal est fixé à 1 250 °C.h, relevable jusqu'à 2 000 °C.h en cas de contraintes particulières, par exemple lorsque le bruit ou la pollution interdisent d'ouvrir les fenêtres la nuit. Au-delà de ce plafond, le projet n'est tout simplement pas conforme. Pour un terrain héraultais, viser le bas de cette fourchette est un objectif de conception, pas un luxe."
      },
      {
        "type": "heading",
        "text": "Orientation et protections solaires : la première ligne de défense"
      },
      {
        "type": "paragraph",
        "text": "Tout commence par l'implantation. Orienter les pièces de vie au sud permet de capter le soleil bas de l'hiver tout en maîtrisant le soleil haut de l'été, plus facile à arrêter qu'on ne le croit. Au sud, une protection fixe bien dimensionnée — débord de toiture, casquette — suffit souvent à mettre la baie vitrée à l'ombre aux heures les plus chaudes, sans pénaliser l'apport solaire d'hiver."
      },
      {
        "type": "paragraph",
        "text": "Les façades est et ouest sont plus délicates : le soleil y est rasant le matin et le soir, et une casquette horizontale n'y suffit pas. On privilégie alors des protections mobiles : volets, stores, brise-soleil orientables. Ce sont elles qui font la différence sur l'indicateur DH, parce qu'elles s'adaptent à l'heure et à la saison."
      },
      {
        "type": "image",
        "src": "/images/projets/chemindesvignes/1.webp",
        "alt": "Logements collectifs DP Architecture dans l'Hérault avec protections solaires et façades pensées pour le confort d'été méditerranéen"
      },
      {
        "type": "heading",
        "text": "L'inertie thermique : stocker la fraîcheur de la nuit"
      },
      {
        "type": "paragraph",
        "text": "Un bâtiment qui reste frais est souvent un bâtiment lourd. L'inertie thermique, apportée par des matériaux massifs, permet de stocker la fraîcheur de la nuit et de la restituer en journée. La température intérieure se lisse : moins de pics l'après-midi, moins de chaleur emmagasinée d'un jour sur l'autre. C'est un levier discret mais déterminant sur le confort réel ressenti."
      },
      {
        "type": "paragraph",
        "text": "L'inertie ne travaille jamais seule. Elle doit être associée à une isolation performante de l'enveloppe, qui freine l'entrée de la chaleur extérieure, et à des protections solaires efficaces. C'est la combinaison de ces trois éléments qui maintient l'intérieur à l'écart des excès de l'été héraultais."
      },
      {
        "type": "heading",
        "text": "Ventilation naturelle et surventilation nocturne"
      },
      {
        "type": "paragraph",
        "text": "En climat méditerranéen, les nuits restent souvent plus fraîches que les après-midi. Cet écart est une ressource. La ventilation naturelle traversante, qui fait circuler l'air d'une façade à l'autre du logement, et la surventilation nocturne, qui ouvre largement le bâtiment la nuit pour évacuer la chaleur accumulée, permettent de décharger l'inertie et de repartir chaque matin sur une base fraîche."
      },
      {
        "type": "paragraph",
        "text": "Encore faut-il que le plan le permette. Des pièces traversantes, des ouvertures bien placées, une circulation d'air pensée dès l'esquisse : ce sont des choix d'architecture, pas des options à rajouter. C'est pour cela que le confort d'été se joue très en amont, sur la table à dessin."
      },
      {
        "type": "image",
        "src": "/images/projets/maisonbaillargue/1.webp",
        "alt": "Maison individuelle conçue par DP Architecture à Baillargues, pensée en architecture bioclimatique pour rester fraîche en été"
      },
      {
        "type": "heading",
        "text": "Végétalisation et ombrage : prolonger le travail de l'architecture"
      },
      {
        "type": "paragraph",
        "text": "Le bâti ne suffit pas toujours seul. La végétalisation et l'ombrage portés par le projet — arbres bien placés, pergolas, traitement des abords — réduisent la chaleur reçue par les façades et l'environnement immédiat. Un mur tenu à l'ombre l'après-midi rayonne moins le soir. Ces aménagements prolongent naturellement le travail des protections solaires et participent, eux aussi, au respect des seuils de confort."
      },
      {
        "type": "paragraph",
        "text": "Il faut le souligner avec mesure : dans les zones chaudes du sud, la réglementation prévoit des possibilités d'adaptation de certaines exigences. Ces marges restent encadrées et susceptibles d'évoluer. L'enjeu n'est pas de s'y réfugier, mais de concevoir d'abord un bâtiment qui tient par sa logique bioclimatique."
      },
      {
        "type": "heading",
        "text": "Concevoir aujourd'hui pour les étés de demain"
      },
      {
        "type": "paragraph",
        "text": "Construire ou rénover dans l'Hérault, c'est anticiper des étés qui se durcissent. La conception bioclimatique méditerranéenne n'est pas une contrainte réglementaire de plus : c'est la voie la plus sûre vers un logement durablement confortable, plus économe et moins dépendant de la climatisation. Avec trente ans d'expérience et une pratique ancrée dans le territoire héraultais, DP Architecture conçoit maisons et logements collectifs autour de cette exigence, dès les premières esquisses. Parlons de votre projet et de la manière dont il peut rester frais, été après été."
      }
    ],
    "contentEN": [
      {
        "type": "paragraph",
        "text": "In the Hérault, summer is no longer a quiet season. The département lies in climate zone H3, the Mediterranean zone, the most exposed to summer heat in the country. Heatwaves are becoming more frequent, longer and more intense. The question is no longer whether your home will get hot, but how it will stay livable without turning air conditioning into a permanent reflex."
      },
      {
        "type": "paragraph",
        "text": "The good news: we know how to design buildings that stay cool in summer through the architecture itself, rather than through a machine added afterwards. This is the very purpose of Mediterranean bioclimatic architecture. At DP Architecture, in Montpellier, it is how we design single-family homes and multi-unit housing from the outset of every project."
      },
      {
        "type": "heading",
        "text": "Summer comfort, now written into the regulations"
      },
      {
        "type": "paragraph",
        "text": "In force since 2022, the RE2020 regulation is no longer limited to winter and heating. It introduces an indicator dedicated to summer comfort: Discomfort Degree-Hours, or DH, expressed in °C.h. In practice, this indicator measures how long, and how intensely, the indoor temperature exceeds a comfort threshold across the whole warm season."
      },
      {
        "type": "paragraph",
        "text": "The benchmarks are clear. Below 350 °C.h, a home is considered comfortable in summer without air conditioning. The maximum regulatory ceiling is set at 1,250 °C.h, raisable to 2,000 °C.h in the case of particular constraints, for example when noise or pollution makes it impossible to open windows at night. Beyond that ceiling, the project is simply non-compliant. On a plot in the Hérault, aiming for the lower end of this range is a design objective, not a luxury."
      },
      {
        "type": "heading",
        "text": "Orientation and solar shading: the first line of defence"
      },
      {
        "type": "paragraph",
        "text": "It all starts with the layout. Orienting living spaces to the south captures the low winter sun while controlling the high summer sun, which is easier to block than one might think. To the south, a well-sized fixed shade — a roof overhang or a brise-soleil — is often enough to keep the glazing in shadow during the hottest hours, without penalising winter solar gains."
      },
      {
        "type": "paragraph",
        "text": "East and west façades are trickier: the sun grazes them in the morning and evening, and a horizontal shade is not enough. Here we favour movable protections: shutters, blinds, adjustable solar louvres. These are what make the difference on the DH indicator, because they adapt to the time of day and the season."
      },
      {
        "type": "image",
        "src": "/images/projets/chemindesvignes/1.webp",
        "alt": "DP Architecture multi-unit housing in the Hérault with solar shading and façades designed for Mediterranean summer comfort"
      },
      {
        "type": "heading",
        "text": "Thermal inertia: storing the coolness of the night"
      },
      {
        "type": "paragraph",
        "text": "A building that stays cool is often a heavy building. Thermal inertia, provided by massive materials, stores the coolness of the night and releases it during the day. The indoor temperature is smoothed out: fewer afternoon peaks, less heat carried over from one day to the next. It is a discreet but decisive lever for the comfort actually experienced."
      },
      {
        "type": "paragraph",
        "text": "Inertia never works alone. It must be combined with a high-performing insulated envelope, which slows the entry of outdoor heat, and with effective solar shading. It is the combination of these three elements that keeps the interior away from the excesses of the Hérault summer."
      },
      {
        "type": "heading",
        "text": "Natural ventilation and night-time over-ventilation"
      },
      {
        "type": "paragraph",
        "text": "In a Mediterranean climate, nights often remain cooler than afternoons. This gap is a resource. Cross-ventilation, which moves air from one façade of the home to the other, and night-time over-ventilation, which opens the building wide at night to flush out accumulated heat, allow the inertia to be discharged and each morning to start from a cool baseline."
      },
      {
        "type": "paragraph",
        "text": "But the floor plan has to allow it. Through-flowing rooms, well-placed openings, an air path considered from the very first sketch: these are architectural choices, not options to be added later. That is why summer comfort is decided very early on, on the drawing board."
      },
      {
        "type": "image",
        "src": "/images/projets/maisonbaillargue/1.webp",
        "alt": "Single-family home designed by DP Architecture in Baillargues, conceived along bioclimatic principles to stay cool in summer"
      },
      {
        "type": "heading",
        "text": "Greenery and shading: extending the work of the architecture"
      },
      {
        "type": "paragraph",
        "text": "The built fabric is not always enough on its own. The greenery and shading carried by the project — well-placed trees, pergolas, treatment of the surroundings — reduce the heat received by the façades and the immediate environment. A wall kept in shadow in the afternoon radiates less heat in the evening. These features naturally extend the work of the solar protections and also contribute to meeting the comfort thresholds."
      },
      {
        "type": "paragraph",
        "text": "This should be said with measure: in the hot zones of the south, the regulation provides for possibilities to adapt certain requirements. These margins remain framed by rules and liable to evolve. The point is not to take refuge in them, but to first design a building that holds up through its own bioclimatic logic."
      },
      {
        "type": "heading",
        "text": "Designing today for tomorrow's summers"
      },
      {
        "type": "paragraph",
        "text": "Building or renovating in the Hérault means anticipating summers that keep getting harsher. Mediterranean bioclimatic design is not just one more regulatory constraint: it is the surest path to a home that stays comfortable for the long term, more economical and less dependent on air conditioning. With thirty years of experience and a practice rooted in the Hérault region, DP Architecture designs homes and multi-unit housing around this requirement, from the very first sketches. Let's talk about your project and how it can stay cool, summer after summer."
      }
    ]
  },
  {
    "id": 9,
    "slug": "renovation-energetique-passoires-thermiques-herault",
    "date": "Mars 2026",
    "dateEN": "March 2026",
    "dateISO": "2026-03-10",
    "dateModifiedISO": "2026-08-07",
    "category": "Conseils",
    "categoryEN": "Advice",
    "image": "/images/projets/puitderouille/1.webp",
    "seoTitle": "Passoires thermiques Hérault : rénover avec DP Architecture",
    "seoDescription": "Passoires thermiques, DPE et aides à la rénovation énergétique dans l'Hérault : DP Architecture guide propriétaires et bailleurs à Montpellier et en Occitanie.",
    "seoKeywords": "rénovation énergétique Hérault, passoire thermique Montpellier, DPE Hérault, MaPrimeRénov Hérault, réhabilitation énergétique Montpellier, audit énergétique Hérault, architecte rénovation Montpellier, interdiction location DPE G",
    "title": "Passoires thermiques dans l'Hérault : que faire et quand ?",
    "titleEN": "Poorly insulated homes in the Hérault: what to do and when",
    "excerpt": "Interdiction de louer les DPE G, F puis E : le calendrier des passoires thermiques se précise. Voici ce que cela implique pour les propriétaires et bailleurs de l'Hérault, et le rôle de l'architecte dans une rénovation énergétique d'ampleur.",
    "excerptEN": "A ban on renting out DPE G, F and then E homes: the thermal-sieve timeline is taking shape. Here is what it means for owners and landlords in Hérault, and the architect's role in an in-depth energy renovation.",
    "content": [
      {
        "type": "paragraph",
        "text": "Vous possédez un logement classé F ou G au DPE dans l'Hérault ? Le calendrier d'interdiction de mise en location se resserre, et il vous concerne directement. Entre obligations légales, gel des loyers et travaux à anticiper, mieux vaut comprendre les règles avant qu'elles ne s'imposent à vous. DP Architecture accompagne propriétaires, bailleurs, copropriétés et collectivités de Montpellier et de tout le département dans leurs projets de réhabilitation et de rénovation énergétique."
      },
      {
        "type": "heading",
        "text": "Passoire thermique : de quoi parle-t-on exactement ?"
      },
      {
        "type": "paragraph",
        "text": "Une passoire thermique désigne un logement classé F ou G au Diagnostic de Performance Énergétique (DPE). Ces biens consomment beaucoup d'énergie pour le chauffage et le confort, avec des factures élevées et un inconfort marqué, l'été comme l'hiver. Dans le climat méditerranéen de l'Hérault, le problème ne se limite pas au froid : la surchauffe estivale pèse tout autant sur le confort et sur la consommation."
      },
      {
        "type": "paragraph",
        "text": "Le DPE classe les logements de A (très performant) à G (très énergivore). C'est cette étiquette qui sert désormais de référence pour les obligations de mise en location. Connaître la classe de votre bien est donc le point de départ de toute réflexion."
      },
      {
        "type": "heading",
        "text": "Le calendrier d'interdiction de mise en location"
      },
      {
        "type": "paragraph",
        "text": "Les échéances sont fixées et progressives. Depuis le 1er janvier 2025, les logements classés G sont interdits à la location, pour les nouveaux baux, les renouvellements et les reconductions tacites. Les logements classés F suivront à partir du 1er janvier 2028, puis les logements classés E à partir du 1er janvier 2034."
      },
      {
        "type": "paragraph",
        "text": "À cela s'ajoute une mesure déjà en vigueur : depuis août 2022, le gel des loyers s'applique aux logements classés F et G. Concrètement, vous ne pouvez pas augmenter le loyer de ces biens. Pour un bailleur de l'Hérault, l'enjeu est double : préserver la valeur locative du patrimoine et éviter qu'un bien ne devienne tout simplement impossible à louer."
      },
      {
        "type": "image",
        "src": "/images/projets/concept/1.webp",
        "alt": "Bâtiment de logements signé DP Architecture dans l'Hérault, enjeu de performance énergétique"
      },
      {
        "type": "heading",
        "text": "Une rénovation globale plutôt que des gestes isolés"
      },
      {
        "type": "paragraph",
        "text": "Pour sortir durablement un logement de la catégorie passoire thermique, empiler quelques travaux ne suffit pas : c'est une rénovation d'ampleur, pensée comme un tout cohérent, qui fait réellement gagner des classes au DPE. Isolation, ventilation, menuiseries, traitement des ponts thermiques et confort d'été se conçoivent ensemble — exactement le type de vision d'ensemble qu'apporte un architecte."
      },
      {
        "type": "paragraph",
        "text": "Plusieurs aides existent pour alléger le coût de ces travaux, comme MaPrimeRénov', l'éco-prêt à taux zéro ou les Certificats d'Économies d'Énergie. Leur montage relève de dispositifs spécifiques ; l'essentiel, en amont, reste un projet bien conçu qui vise vraiment le gain de performance attendu."
      },
      {
        "type": "heading",
        "text": "Pourquoi faire appel à un architecte pour une rénovation d'ampleur"
      },
      {
        "type": "paragraph",
        "text": "Une rénovation énergétique réussie ne se résume pas à empiler des équipements. Elle commence par un diagnostic sérieux du bâti existant : nature des murs, ponts thermiques, ventilation, orientation, état de la toiture et des menuiseries. L'architecte porte ce regard d'ensemble et définit une stratégie cohérente, où chaque poste de travaux renforce les autres au lieu de les contrarier."
      },
      {
        "type": "paragraph",
        "text": "Daniela Parito Sorrenti, architecte, intervient depuis 2014 à Montpellier et dans tout l'Hérault. Le cabinet a notamment réhabilité la Maison Galibert à Baillargues, transformée en poste de police municipale, et mené des rénovations énergétiques de maisons individuelles. Il conçoit selon les exigences de la RE2020, du label BBC et du bâtiment passif, et adapte les choix techniques à chaque situation. Cette approche sur mesure évite les erreurs coûteuses et garantit un résultat durable."
      },
      {
        "type": "image",
        "src": "/images/projets/lagardie/1.webp",
        "alt": "Réalisation résidentielle DP Architecture en Occitanie, approche énergétique du bâti"
      },
      {
        "type": "heading",
        "text": "Le bâti méditerranéen : des choix techniques adaptés"
      },
      {
        "type": "paragraph",
        "text": "Rénover dans l'Hérault impose de raisonner autrement que dans le nord de la France. Ici, le confort d'été est déterminant. Protection solaire, inertie des matériaux, ventilation naturelle et traitement des apports de chaleur comptent autant que l'isolation contre le froid. Une isolation mal pensée peut même aggraver la surchauffe estivale si elle néglige cette dimension."
      },
      {
        "type": "paragraph",
        "text": "DP Architecture conçoit des solutions ajustées au climat local et au caractère du bâti, qu'il s'agisse d'une maison individuelle, d'un immeuble de logements collectifs ou d'un équipement public. L'objectif : un logement plus sobre, plus confortable toute l'année, et conforme aux échéances réglementaires."
      },
      {
        "type": "heading",
        "text": "Un accompagnement de l'audit au suivi de chantier"
      },
      {
        "type": "paragraph",
        "text": "Au-delà de la conception, l'architecte assure le suivi de chantier et la coordination des entreprises. Il veille à la qualité d'exécution et à la cohérence d'ensemble du projet, point souvent décisif pour atteindre réellement le gain de performance visé."
      },
      {
        "type": "paragraph",
        "text": "Que vous soyez propriétaire, bailleur, copropriété ou collectivité, anticiper la sortie d'une passoire thermique vous évite de subir les échéances. DP Architecture met son expérience de la réhabilitation au service de votre projet, à Montpellier comme partout dans l'Hérault. Parlons de votre logement et des solutions adaptées à votre bâti."
      }
    ],
    "contentEN": [
      {
        "type": "paragraph",
        "text": "Do you own a home rated F or G on the EPC in Hérault? The timeline banning these properties from the rental market is tightening, and it concerns you directly. Between legal obligations, rent freezes and works to plan ahead, it is best to understand the rules before they apply to you. DP Architecture supports owners, landlords, condominiums and local authorities in Montpellier and across the department with their rehabilitation and energy renovation projects."
      },
      {
        "type": "heading",
        "text": "Thermal Sieve: What Are We Really Talking About?"
      },
      {
        "type": "paragraph",
        "text": "A thermal sieve refers to a home rated F or G on the Energy Performance Certificate (EPC). These properties consume a great deal of energy for heating and comfort, with high bills and marked discomfort in both summer and winter. In the Mediterranean climate of Hérault, the issue is not limited to cold: summer overheating weighs just as heavily on comfort and consumption."
      },
      {
        "type": "paragraph",
        "text": "The EPC rates homes from A (very efficient) to G (very energy-intensive). This rating is now the reference for rental obligations. Knowing your property's class is therefore the starting point for any reflection."
      },
      {
        "type": "heading",
        "text": "The Rental Ban Timeline"
      },
      {
        "type": "paragraph",
        "text": "The deadlines are set and progressive. Since 1 January 2025, homes rated G have been banned from rental, for new leases, renewals and tacit renewals. Homes rated F will follow from 1 January 2028, then homes rated E from 1 January 2034."
      },
      {
        "type": "paragraph",
        "text": "On top of this comes a measure already in force: since August 2022, a rent freeze has applied to homes rated F and G. In practice, you cannot increase the rent on these properties. For a landlord in Hérault, the stakes are twofold: preserving the rental value of the property and avoiding a home becoming simply impossible to rent out."
      },
      {
        "type": "image",
        "src": "/images/projets/concept/1.webp",
        "alt": "Residential building by DP Architecture in the Hérault, focused on energy performance"
      },
      {
        "type": "heading",
        "text": "A whole-building renovation, not isolated measures"
      },
      {
        "type": "paragraph",
        "text": "To lift a home out of thermal-sieve status for good, stacking up a few measures is not enough: it takes an in-depth renovation, conceived as a coherent whole, to genuinely move the property up the EPC scale. Insulation, ventilation, joinery, thermal-bridge treatment and summer comfort are designed together — exactly the kind of overall vision an architect brings."
      },
      {
        "type": "paragraph",
        "text": "Several forms of aid exist to ease the cost of these works, such as MaPrimeRénov', the zero-interest eco-loan or Energy Savings Certificates. Putting them together follows specific schemes; what matters most, upstream, is a well-designed project that genuinely targets the expected performance gain."
      },
      {
        "type": "heading",
        "text": "Why Call on an Architect for an In-Depth Renovation"
      },
      {
        "type": "paragraph",
        "text": "A successful energy renovation is not just a matter of stacking up equipment. It begins with a serious diagnosis of the existing building: the nature of the walls, thermal bridges, ventilation, orientation, and the condition of the roof and joinery. The architect brings this overall view and defines a coherent strategy, where each set of works reinforces the others rather than working against them."
      },
      {
        "type": "paragraph",
        "text": "Daniela Parito Sorrenti, an architect, has been working since 2014 in Montpellier and across Hérault. The practice notably rehabilitated the Maison Galibert in Baillargues, turning it into a municipal police station, and has carried out energy renovations of single-family homes. It designs to the requirements of RE2020, the BBC label and passive building standards, adapting technical choices to each situation. This tailor-made approach avoids costly mistakes and ensures a lasting result."
      },
      {
        "type": "image",
        "src": "/images/projets/lagardie/1.webp",
        "alt": "Residential project by DP Architecture in Occitanie, with an energy-focused approach to the building"
      },
      {
        "type": "heading",
        "text": "Mediterranean Buildings: Suitable Technical Choices"
      },
      {
        "type": "paragraph",
        "text": "Renovating in Hérault calls for a different mindset than in the north of France. Here, summer comfort is decisive. Solar protection, material inertia, natural ventilation and managing heat gains matter as much as insulation against the cold. Poorly thought-out insulation can even worsen summer overheating if it neglects this dimension."
      },
      {
        "type": "paragraph",
        "text": "DP Architecture designs solutions tuned to the local climate and to the character of the building, whether an individual house, a collective housing block or a public facility. The goal: a home that is more energy-efficient, more comfortable all year round, and compliant with regulatory deadlines."
      },
      {
        "type": "heading",
        "text": "Support from Audit to Site Supervision"
      },
      {
        "type": "paragraph",
        "text": "Beyond design, the architect handles site supervision and the coordination of contractors. They ensure quality of execution and the overall coherence of the project, often a decisive factor in genuinely achieving the targeted performance gain."
      },
      {
        "type": "paragraph",
        "text": "Whether you are an owner, a landlord, a condominium or a local authority, anticipating the exit from thermal-sieve status spares you from being caught out by the deadlines. DP Architecture puts its rehabilitation experience at the service of your project, in Montpellier and throughout Hérault. Let's talk about your home and the solutions suited to your building."
      }
    ]
  },
  {
    "id": 10,
    "slug": "extension-agrandissement-maison-herault",
    "date": "Août 2026",
    "dateEN": "August 2026",
    "dateISO": "2026-08-07",
    "category": "Conseils",
    "categoryEN": "Advice",
    "image": "/images/projets/maisonbaillargue/2.webp",
    "seoTitle": "Extension de maison Hérault : le guide | DP Architecture",
    "seoDescription": "Extension de maison dans l'Hérault : permis ou déclaration préalable, seuils 20/40/150 m², taxe d'aménagement, délais. Le guide clair pour votre projet.",
    "seoKeywords": "extension de maison Hérault, agrandissement maison Montpellier, surélévation maison Hérault, permis de construire extension, déclaration préalable extension, architecte extension Montpellier, réglementation véranda Hérault, extension maison Mauguio",
    "title": "Extension de maison dans l'Hérault : agrandir, surélever, véranda",
    "titleEN": "House Extensions in the Hérault: Extending, Adding a Storey, Building a Veranda",
    "excerpt": "Extension, surélévation ou véranda : dans l'Hérault, tout se joue avant le premier coup de crayon, entre les seuils de 20, 40 et 150 m², le PLU de votre commune et l'avis de l'ABF. Ce guide détaille les règles applicables, les délais, la taxe d'aménagement et les pièges qui font refuser un dossier.",
    "excerptEN": "Extension, added storey or veranda: in the Hérault, everything is decided before the first sketch, between the 20, 40 and 150 m² thresholds, your commune's PLU (local planning scheme) and the ABF's opinion. This guide sets out the applicable rules, the timescales, the development tax and the pitfalls that get applications refused.",
    "faq": [
      {
        "q": "Puis-je agrandir ma maison sans faire appel à un architecte ?",
        "a": "Oui, si vous êtes un particulier qui fait construire pour lui-même et que la surface de plancher totale après travaux ne dépasse pas 150 m². Au-delà de ce seuil, dès lors qu'un permis de construire est requis, le recours à un architecte devient obligatoire. Les sociétés et les SCI y sont soumises quelle que soit la surface. La [première consultation](/contact) au cabinet permet de vérifier votre cas."
      },
      {
        "q": "Mon voisin peut-il contester mon extension une fois l'autorisation obtenue ?",
        "a": "Oui. Une fois l'autorisation délivrée, elle doit être affichée sur le terrain, et c'est cet affichage qui fait courir le délai de recours des tiers. Un affichage conforme et maintenu est donc dans votre intérêt. Un dossier respectant les hauteurs, les reculs et l'aspect imposés par le PLU réduit fortement la prise offerte à un recours."
      },
      {
        "q": "Combien de temps faut-il compter entre la première esquisse et le début du chantier ?",
        "a": "L'instruction seule dure 1 mois pour une déclaration préalable et 2 mois pour un permis de maison individuelle, avec un mois de plus en abords de monument historique ou en site patrimonial remarquable. Il faut y ajouter la conception, le montage des pièces du dossier puis la consultation des entreprises. Prévoyez donc plusieurs mois avant le premier coup de pioche, et davantage si l'Architecte des Bâtiments de France doit se prononcer."
      },
      {
        "q": "Faut-il isoler toute la maison existante quand on construit une extension ?",
        "a": "Non. La RE2020 s'applique à l'extension elle-même, avec des exigences graduées selon sa taille, et non au bâtiment existant. Le point vraiment sensible est la jonction entre l'ancien et le neuf : c'est là que se logent les ponts thermiques et les défauts d'étanchéité à l'air. Si votre maison est énergivore, la question de sa [rénovation énergétique](/actualites/renovation-energetique-passoires-thermiques-herault) se traite comme un projet distinct."
      }
    ],
    "faqEN": [
      {
        "q": "Can I extend my house without appointing an architect?",
        "a": "Yes, if you are a private individual building for your own use and the total surface de plancher after the works does not exceed 150 m². Above that threshold, as soon as a permis de construire is required, appointing an architect becomes compulsory. Companies and SCIs are subject to the requirement whatever the surface area. The [first consultation](/contact) at the practice is enough to check your own case."
      },
      {
        "q": "Can my neighbour challenge my extension once the authorisation has been granted?",
        "a": "Yes. Once granted, the authorisation must be displayed on site, and it is that site notice which starts the third-party appeal period running. Keeping a compliant notice in place is therefore in your own interest. An application that respects the heights, set-backs and appearance required by the PLU greatly reduces the grounds available for a challenge."
      },
      {
        "q": "How long does it take between the first sketch and the start of work on site?",
        "a": "Processing alone takes 1 month for a déclaration préalable and 2 months for a single-house permit, with one extra month within the setting of a listed monument or in a site patrimonial remarquable. To that you must add design time, assembling the application documents and then tendering. Allow several months before the first spade goes in, and more if the Architecte des Bâtiments de France has to give an opinion."
      },
      {
        "q": "Does an extension mean insulating the whole of the existing house?",
        "a": "No. RE2020 applies to the extension itself, with requirements graduated according to its size, not to the existing building. The genuinely sensitive point is the junction between old and new: that is where thermal bridges and air-tightness defects occur. If your house is energy-hungry, its [energy retrofit](/actualites/renovation-energetique-passoires-thermiques-herault) is best handled as a separate project."
      }
    ],
    "content": [
      {
        "type": "paragraph",
        "text": "Vous manquez d'une chambre, d'un bureau, d'une vraie pièce de vie. Déménager coûte cher, et le marché autour de Montpellier ne facilite rien. Agrandir l'existant est souvent plus rationnel. Mais une **extension de maison** dans l'Hérault se gagne d'abord sur le papier : surface créée, zonage du PLU, seuil d'autorisation, avis éventuel de l'Architecte des Bâtiments de France, taxe d'aménagement. Voici les règles et les erreurs qui font refuser un dossier."
      },
      {
        "type": "heading",
        "text": "Surface de plancher ou emprise au sol : la première chose à comprendre"
      },
      {
        "type": "paragraph",
        "text": "Tout le régime des autorisations repose sur deux notions que l'on confond en permanence. Se tromper, c'est déposer le mauvais dossier et perdre deux mois."
      },
      {
        "type": "subheading",
        "text": "La surface de plancher"
      },
      {
        "type": "paragraph",
        "text": "Elle se calcule au nu intérieur des façades, niveau par niveau, pour les espaces clos et couverts (article R.111-22 du code de l'urbanisme). On déduit notamment ce qui est sous 1,80 m de hauteur sous plafond, les trémies d'escalier, le stationnement et les combles non aménageables. Une pièce mansardée compte donc bien moins de surface de plancher que de surface au sol."
      },
      {
        "type": "subheading",
        "text": "L'emprise au sol"
      },
      {
        "type": "paragraph",
        "text": "C'est la projection verticale du volume bâti, débords et surplombs inclus (article R*420-1). En pratique : une surélévation crée de la surface de plancher sans emprise au sol ; une pergola ou un carport créent de l'emprise sans surface de plancher ; une véranda ou une extension classique créent les deux. C'est la plus contraignante des deux qui commande la procédure."
      },
      {
        "type": "heading",
        "text": "Extension de maison Hérault : déclaration préalable ou permis de construire ?"
      },
      {
        "type": "paragraph",
        "text": "Les articles R*421-14 et R*421-17 du code de l'urbanisme fixent le régime applicable aux extensions et agrandissements d'une construction existante."
      },
      {
        "type": "list",
        "items": [
          "**Jusqu'à 5 m² créés** : la surface ne déclenche rien, mais les travaux modifient l'aspect extérieur du bâtiment. Une déclaration préalable reste nécessaire en pratique.",
          "**Plus de 5 m² et jusqu'à 20 m²** : déclaration préalable.",
          "**Plus de 20 m²** : permis de construire.",
          "**En zone urbaine (zone U) d'un PLU** : le passage au permis est repoussé à 40 m², sauf l'exception ci-dessous."
        ]
      },
      {
        "type": "subheading",
        "text": "Le seuil de 40 m² ne s'applique pas partout"
      },
      {
        "type": "paragraph",
        "text": "C'est l'erreur la plus répandue. Les 40 m² sont réservés aux zones urbaines d'un PLU ou d'un document en tenant lieu. En zone A, N ou AU, dans une commune en carte communale ou au règlement national d'urbanisme, le seuil reste 20 m². Dans l'Hérault, la nuance compte : beaucoup de communes de la plaine et de l'arrière-pays ont un tissu bâti diffus hors zone U. Lisez le règlement du PLU avant tout dessin : [Mauguio](/architecte-mauguio), [Baillargues](/architecte-baillargues) et [Béziers](/architecte-beziers) n'ont ni les mêmes hauteurs, ni les mêmes emprises maximales."
      },
      {
        "type": "subheading",
        "text": "Le piège des 20 à 40 m² en zone U"
      },
      {
        "type": "paragraph",
        "text": "Même en zone U, une extension de 20 à 40 m² repasse en permis de construire si elle porte la surface de plancher totale au-delà de 150 m². Exemple : maison de 135 m², extension de 25 m², soit 160 m². C'est un permis, pas une déclaration préalable."
      },
      {
        "type": "paragraph",
        "text": "Retenez ceci : ces seuils fixent la **procédure**, pas le droit à construire. Le PLU peut interdire l'extension, plafonner la hauteur, imposer un recul ou un type de tuile. Une déclaration préalable se refuse aussi bien qu'un permis. Dans la plaine littorale, vérifiez aussi le PPRI."
      },
      {
        "type": "heading",
        "text": "Quand l'architecte est-il obligatoire pour une extension ?"
      },
      {
        "type": "paragraph",
        "text": "L'article R*431-2 dispense de recours à l'architecte la personne physique qui construit ou modifie **pour elle-même** un bâtiment non agricole dont la surface de plancher n'excède pas 150 m². Le seuil est passé de 170 à 150 m² en 2016, pour les permis déposés depuis le 1er mars 2017. Trois précisions changent tout."
      },
      {
        "type": "list",
        "items": [
          "L'obligation vise le projet architectural joint à une **demande de permis de construire**. Une extension relevant d'une simple déclaration préalable n'y est donc en principe pas soumise, même si le total dépasse 150 m² : une lecture largement admise, que certains services instructeurs formulent toutefois de façon plus large. Faites-la confirmer par votre mairie avant le dépôt.",
          "Le seuil s'apprécie sur la surface **totale après travaux**, existant compris. Maison de 140 m² plus extension de 25 m² égale 165 m² : architecte obligatoire dès lors qu'un permis est requis.",
          "La dispense vise les **personnes physiques**. Une SCI ou une société doit recourir à un architecte quelle que soit la surface."
        ]
      },
      {
        "type": "paragraph",
        "text": "Le critère retenu par l'administration pour une maison est la surface de plancher, pas l'emprise au sol, selon une réponse ministérielle de décembre 2018. Certains services instructeurs raisonnent encore en emprise : en cas de doute, la mairie tranche avant le dépôt. Voir aussi [ce que couvre une mission d'architecte](/missions) et [construire une maison neuve avec un architecte dans l'Hérault](/actualites/maison-individuelle-herault-architecte-dplg)."
      },
      {
        "type": "heading",
        "text": "Surélévation, véranda, garage, piscine : chaque cas a ses règles"
      },
      {
        "type": "subheading",
        "text": "La surélévation"
      },
      {
        "type": "paragraph",
        "text": "Pas de régime spécifique : mêmes seuils de 5, 20 et 40 m². Particularité, elle ne crée que de la surface de plancher, qui décide donc seule de la procédure. Techniquement : il faut vérifier la capacité portante des murs et des fondations, donc un diagnostic de structure avant de dessiner. C'est la piste à étudier quand le terrain est petit ou déjà saturé."
      },
      {
        "type": "subheading",
        "text": "La véranda"
      },
      {
        "type": "paragraph",
        "text": "Close et couverte, elle crée surface de plancher et emprise au sol, et suit le régime des travaux sur existant. Le vrai sujet n'est pas administratif, il est thermique : mal orientée et non protégée, une véranda devient inhabitable de juin à septembre. Débord de toiture, brise-soleil, ventilation traversante et vitrage adapté se décident à la conception."
      },
      {
        "type": "subheading",
        "text": "Le garage, l'abri de jardin, le pool house"
      },
      {
        "type": "paragraph",
        "text": "Le régime change complètement si la construction est **isolée**, non accolée à la maison. Aucune formalité jusqu'à 5 m² inclus et 12 m de hauteur, déclaration préalable au-delà de 5 m² et jusqu'à 20 m² (toujours sous 12 m de hauteur), permis de construire au-delà de 20 m². Le seuil de 40 m² en zone U ne s'applique pas ici : il est réservé aux travaux sur construction existante, jamais aux constructions nouvelles indépendantes."
      },
      {
        "type": "subheading",
        "text": "La piscine, la pergola, le carport"
      },
      {
        "type": "paragraph",
        "text": "Un bassin de 10 m² ou moins ne demande aucune formalité. De 10 à 100 m², déclaration préalable, à condition qu'il ne soit pas couvert ou que sa couverture reste sous 1,80 m. Permis au-delà de 100 m², ou dès que la couverture atteint 1,80 m. Pergola et carport, non clos, ne créent que de l'emprise au sol."
      },
      {
        "type": "image",
        "src": "/images/projets/clubstade/1.webp",
        "alt": "Extension et rénovation d'un bâtiment existant à Baillargues, dans l'Hérault, par DP Architecture"
      },
      {
        "type": "heading",
        "text": "Délais d'instruction et secteurs protégés dans l'Hérault"
      },
      {
        "type": "list",
        "items": [
          "Déclaration préalable : **1 mois**.",
          "Permis de construire pour une maison individuelle ou ses annexes : **2 mois**.",
          "Autres permis de construire et permis d'aménager : **3 mois**.",
          "Abords de monument historique ou site patrimonial remarquable : délai majoré d'un mois, soit 2 mois en déclaration préalable et 3 mois pour un permis de maison individuelle.",
          "Immeuble classé au titre des monuments historiques, site classé, cœur de parc national : jusqu'à 5 mois."
        ]
      },
      {
        "type": "paragraph",
        "text": "Dans l'Hérault, l'avis de l'Architecte des Bâtiments de France concerne beaucoup de projets : centres anciens, abords d'une église, d'un château ou de remparts. [Pézenas](/architecte-pezenas) en est l'exemple le plus connu, mais la contrainte existe aussi dans la couronne montpelliéraine. En secteur protégé, le cabinet a mené la [réhabilitation lourde de la Maison Galibert à Baillargues](/projects), livrée en juin 2021 : enduit à la chaux naturelle en trois couches, tuiles canal d'origine reposées, moulures de façade conservées, menuiseries bois. Ce dossier-là se prépare en amont."
      },
      {
        "type": "paragraph",
        "text": "Une autorisation vaut 3 ans, prorogeable deux fois un an. Le silence de l'administration au terme du délai vaut accord tacite, mais l'affichage sur le terrain et le délai de recours des tiers restent à respecter."
      },
      {
        "type": "heading",
        "text": "Extension de maison : ce que ça coûte au-delà des travaux"
      },
      {
        "type": "subheading",
        "text": "La taxe d'aménagement"
      },
      {
        "type": "paragraph",
        "text": "Elle est due dès qu'une autorisation crée de la surface taxable. Le calcul : surface taxable créée, multipliée par la valeur forfaitaire au mètre carré, multipliée par la somme du taux communal et du taux départemental."
      },
      {
        "type": "list",
        "items": [
          "Valeur forfaitaire 2026 hors Île-de-France : **892 € par m²**, révisée chaque année.",
          "Taux communal de 1 à 5 %, jusqu'à 20 % dans certains secteurs ; taux départemental plafonné à 2,5 %.",
          "Abattement de 50 % sur la valeur forfaitaire pour les 100 premiers m² de local à usage d'habitation principale et ses annexes.",
          "Exonération de plein droit jusqu'à 5 m² inclus et pour les reconstructions à l'identique après sinistre.",
          "Piscine : environ 251 € par m² de bassin en 2026. Pergola, auvent et terrasse ne sont pas taxables, faute d'être clos et couverts."
        ]
      },
      {
        "type": "paragraph",
        "text": "Depuis 2022, les éléments de calcul se déclarent aux impôts, non plus en mairie, dans les 90 jours suivant l'achèvement fiscal des locaux, via l'espace « Gérer mes biens immobiliers » sur impots.gouv.fr. Paiement en une fois sous 1 500 €. Ne confondez pas cette taxe ponctuelle avec la revalorisation de la taxe foncière, annuelle : un agrandissement déclenche les deux."
      },
      {
        "type": "subheading",
        "text": "Le prix au m² : la réponse honnête"
      },
      {
        "type": "paragraph",
        "text": "Aucune institution ne publie de fourchette de prix au m² pour une extension. Les chiffres qui circulent viennent de plateformes commerciales et se contredisent d'un site à l'autre. Ce qui fait vraiment varier un budget : l'accès au chantier, la nature du sol, la reprise de structure, le mode constructif et le niveau de finition. Le seul chiffre fiable est un devis établi sur un projet dessiné et quantifié. Les honoraires d'architecte, eux, sont libres : aucun barème officiel n'existe."
      },
      {
        "type": "heading",
        "text": "RE2020 et confort d'été : l'extension ne doit pas dégrader la maison"
      },
      {
        "type": "paragraph",
        "text": "Depuis le 1er janvier 2023, la RE2020 s'applique à toutes les extensions de maison individuelle soumises à permis ou à déclaration préalable, quelle que soit leur surface. Les exigences sont graduées : d'après le Cerema, une petite extension relève de simples exigences de moyens (parois, vitrages, ponts thermiques, ventilation, chauffage), tandis qu'une grande extension bascule vers la réglementation complète avec étude thermique. Une attestation RE2020 est à joindre au dossier."
      },
      {
        "type": "paragraph",
        "text": "Le vrai enjeu méditerranéen, c'est l'été. Une extension largement vitrée plein sud sans protection solaire se transforme en serre dès juin. Orientation, débord de toiture, pergola, inertie, ventilation nocturne : ces choix se prennent à l'esquisse et ne coûtent presque rien à ce moment-là. Ils sont détaillés dans [notre guide de l'architecture bioclimatique méditerranéenne](/actualites/architecture-bioclimatique-mediterraneenne-herault)."
      },
      {
        "type": "image",
        "src": "/images/projets/maisonbaillargue/3.webp",
        "alt": "Terrasse bois et pergola protégeant les grandes baies sud d'une maison individuelle réalisée par DP Architecture à Baillargues, dans l'Hérault"
      },
      {
        "type": "heading",
        "text": "Comment l'architecte vous accompagne, de l'esquisse à la réception"
      },
      {
        "type": "paragraph",
        "text": "Daniela Parito Sorrenti est architecte, diplômée de la Faculté d'architecture et d'urbanisme de Rome. Elle a exercé vingt-quatre ans en agences parisiennes et régionales avant de fonder son cabinet à Montpellier en 2014, et intervient dans tout l'Hérault. Le cabinet est architecte : il conçoit, monte le dossier d'urbanisme et suit le chantier. Il n'est ni constructeur, ni entreprise générale, ni vendeur de maisons clés en main."
      },
      {
        "type": "list",
        "items": [
          "**Faisabilité** : lecture du PLU, du zonage, des servitudes et du PPRI, pour savoir ce que votre terrain autorise réellement.",
          "**Conception** : esquisse, avant-projet sommaire puis détaillé, en articulant l'extension avec l'existant, la lumière et l'orientation.",
          "**Dossier d'autorisation** : déclaration préalable ou permis, pièces graphiques, insertion paysagère, attestation RE2020, dialogue avec l'ABF si le secteur l'impose.",
          "**Consultation des entreprises** : mise en concurrence sur un dossier précis, comparaison des devis à prestation égale.",
          "**Suivi de chantier et réception** : visites, contrôle de l'exécution, validation des situations, levée des réserves."
        ]
      },
      {
        "type": "paragraph",
        "text": "La première consultation est gratuite. Elle sert à répondre à la seule question qui compte au départ : votre projet est-il faisable, et sous quelle procédure. [Décrivez-nous votre projet d'extension](/contact), par téléphone au 06 14 90 25 13 ou au cabinet, 663 rue du Pré aux Clercs à Montpellier."
      }
    ],
    "contentEN": [
      {
        "type": "paragraph",
        "text": "You are short of a bedroom, a study, a proper living space. Moving is expensive, and the market around Montpellier makes nothing easier. Extending what you already have is often the more rational choice. But a **house extension** in the Hérault is won or lost on paper first: floor area created, PLU (local planning scheme) zoning, the authorisation threshold, a possible opinion from the Architecte des Bâtiments de France (state heritage architect), development tax. Here are the rules, and the mistakes that get applications refused."
      },
      {
        "type": "heading",
        "text": "Surface de plancher or emprise au sol: the first thing to understand"
      },
      {
        "type": "paragraph",
        "text": "The entire authorisation regime rests on two concepts that are constantly confused. Get them wrong and you file the wrong application, losing two months."
      },
      {
        "type": "subheading",
        "text": "Surface de plancher (floor area)"
      },
      {
        "type": "paragraph",
        "text": "It is measured from the internal face of the façades, storey by storey, for enclosed and covered spaces (article R.111-22 of the planning code). Deductions include anything under 1.80 m of head height, stairwell openings, parking and lofts that cannot be converted. A room under a sloping roof therefore counts for far less surface de plancher than its ground footprint suggests."
      },
      {
        "type": "subheading",
        "text": "Emprise au sol (building footprint)"
      },
      {
        "type": "paragraph",
        "text": "This is the vertical projection of the built volume, including overhangs and projections (article R*420-1). In practice: an added storey creates surface de plancher without emprise au sol; a pergola or a carport creates footprint without floor area; a veranda or a conventional extension creates both. Whichever of the two is the more restrictive determines the procedure."
      },
      {
        "type": "heading",
        "text": "House extension in the Hérault: déclaration préalable or permis de construire?"
      },
      {
        "type": "paragraph",
        "text": "Articles R*421-14 and R*421-17 of the planning code set the regime applicable to extensions and enlargements of an existing building."
      },
      {
        "type": "list",
        "items": [
          "**Up to 5 m² created**: the surface area alone triggers nothing, but the works alter the external appearance of the building. A déclaration préalable (prior declaration of works) remains necessary in practice.",
          "**More than 5 m² and up to 20 m²**: déclaration préalable.",
          "**More than 20 m²**: permis de construire (building permit).",
          "**In an urban zone (zone U) of a PLU**: the switch to a permit is pushed back to 40 m², subject to the exception below."
        ]
      },
      {
        "type": "subheading",
        "text": "The 40 m² threshold does not apply everywhere"
      },
      {
        "type": "paragraph",
        "text": "This is the most widespread error. The 40 m² figure is reserved for urban zones covered by a PLU or an equivalent document. In zones A, N or AU, in a commune governed by a carte communale (simplified planning map) or by the national planning rules, the threshold stays at 20 m². In the Hérault the distinction matters: many communes on the plain and in the hinterland have scattered building patterns outside zone U. Read the PLU regulations before drawing anything: [Mauguio](/architecte-mauguio), [Baillargues](/architecte-baillargues) and [Béziers](/architecte-beziers) share neither the same height limits nor the same maximum footprints."
      },
      {
        "type": "subheading",
        "text": "The 20 to 40 m² trap in zone U"
      },
      {
        "type": "paragraph",
        "text": "Even in zone U, an extension of 20 to 40 m² reverts to a permis de construire if it takes the total surface de plancher beyond 150 m². Example: a 135 m² house plus a 25 m² extension makes 160 m². That is a permit, not a déclaration préalable."
      },
      {
        "type": "paragraph",
        "text": "Remember this: these thresholds set the **procedure**, not the right to build. The PLU can prohibit an extension, cap the height, impose a set-back or a specific type of roof tile. A déclaration préalable can be refused just as readily as a permit. On the coastal plain, also check the PPRI (flood risk prevention plan)."
      },
      {
        "type": "heading",
        "text": "When is an architect compulsory for an extension?"
      },
      {
        "type": "paragraph",
        "text": "Article R*431-2 exempts from the requirement to use an architect any private individual who builds or alters **for their own use** a non-agricultural building whose surface de plancher does not exceed 150 m². The threshold dropped from 170 to 150 m² in 2016, for permits filed from 1 March 2017 onwards. Three points change everything."
      },
      {
        "type": "list",
        "items": [
          "The requirement concerns the architectural design submitted with a **permis de construire application**. An extension falling under a simple déclaration préalable is therefore in principle not subject to it, even if the total exceeds 150 m²: a widely accepted reading, though some planning departments state it more broadly. Have your town hall confirm the point before you file.",
          "The threshold is assessed on the **total surface after the works**, existing building included. A 140 m² house plus a 25 m² extension equals 165 m²: an architect becomes compulsory as soon as a permit is required.",
          "The exemption applies to **private individuals**. An SCI (property holding company) or any company must appoint an architect whatever the surface area."
        ]
      },
      {
        "type": "paragraph",
        "text": "For a house, the criterion applied by the authorities is the surface de plancher, not the emprise au sol, according to a ministerial answer of December 2018. Some planning departments still reason in terms of footprint: if in doubt, let the town hall settle the point before you file. See also [what an architect's appointment covers](/missions) and [building a new house with an architect in the Hérault](/actualites/maison-individuelle-herault-architecte-dplg)."
      },
      {
        "type": "heading",
        "text": "Added storey, veranda, garage, swimming pool: each case has its own rules"
      },
      {
        "type": "subheading",
        "text": "Adding a storey"
      },
      {
        "type": "paragraph",
        "text": "No specific regime: the same 5, 20 and 40 m² thresholds apply. The particularity is that it creates surface de plancher only, which therefore governs the procedure on its own. Technically, the load-bearing capacity of the walls and foundations has to be checked, so a structural survey comes before any drawing. This is the option to explore when the plot is small or already built up."
      },
      {
        "type": "subheading",
        "text": "The veranda"
      },
      {
        "type": "paragraph",
        "text": "Enclosed and covered, it creates both surface de plancher and emprise au sol, and follows the regime for works on an existing building. The real issue is not administrative but thermal: badly oriented and unprotected, a veranda becomes uninhabitable from June to September. Roof overhang, brise-soleil, cross ventilation and appropriate glazing are all decided at design stage."
      },
      {
        "type": "subheading",
        "text": "Garages, garden sheds and pool houses"
      },
      {
        "type": "paragraph",
        "text": "The regime changes completely if the structure is **detached**, not attached to the house. No formality up to and including 5 m² and 12 m in height, a déclaration préalable above 5 m² and up to 20 m² (still below 12 m in height), and a permis de construire above 20 m². The 40 m² threshold in zone U does not apply here: it is reserved for works on an existing building, never for new detached structures."
      },
      {
        "type": "subheading",
        "text": "Swimming pools, pergolas and carports"
      },
      {
        "type": "paragraph",
        "text": "A pool of 10 m² or less requires no formality. From 10 to 100 m², a déclaration préalable applies, provided it is uncovered or its cover stays below 1.80 m. A permit is required above 100 m², or as soon as the cover reaches 1.80 m. Pergolas and carports, being open-sided, create emprise au sol only."
      },
      {
        "type": "image",
        "src": "/images/projets/clubstade/1.webp",
        "alt": "Extension and renovation of an existing building in Baillargues, Hérault, by DP Architecture"
      },
      {
        "type": "heading",
        "text": "Processing times and protected areas in the Hérault"
      },
      {
        "type": "list",
        "items": [
          "Déclaration préalable: **1 month**.",
          "Permis de construire for a single house or its outbuildings: **2 months**.",
          "Other building permits and permis d'aménager (development permits): **3 months**.",
          "Within the setting of a listed monument or a site patrimonial remarquable (remarkable heritage site): one month added, so 2 months for a déclaration préalable and 3 months for a house permit.",
          "Building listed as a historic monument, classified site, or the core of a national park: up to 5 months."
        ]
      },
      {
        "type": "paragraph",
        "text": "In the Hérault, the opinion of the Architecte des Bâtiments de France affects a great many projects: historic centres, the setting of a church, a château or ramparts. [Pézenas](/architecte-pezenas) is the best-known example, but the constraint also applies across the Montpellier belt. In a protected area, the practice carried out the [major rehabilitation of Maison Galibert in Baillargues](/projects), delivered in June 2021: three-coat natural lime render, original canal tiles relaid, façade mouldings preserved, timber joinery. That kind of application is prepared well in advance."
      },
      {
        "type": "paragraph",
        "text": "An authorisation is valid for 3 years, extendable twice by one year. Silence from the authorities once the deadline has passed amounts to tacit approval, but the site notice and the third-party appeal period still have to be observed."
      },
      {
        "type": "heading",
        "text": "House extensions: the costs beyond the building work"
      },
      {
        "type": "subheading",
        "text": "The taxe d'aménagement (development tax)"
      },
      {
        "type": "paragraph",
        "text": "It falls due as soon as an authorisation creates taxable surface area. The calculation: taxable surface created, multiplied by the flat-rate value per square metre, multiplied by the sum of the communal rate and the departmental rate."
      },
      {
        "type": "list",
        "items": [
          "2026 flat-rate value outside Île-de-France: **892 € per m²**, revised annually.",
          "Communal rate of 1 to 5%, up to 20% in certain sectors; departmental rate capped at 2.5%.",
          "A 50% reduction on the flat-rate value for the first 100 m² of premises used as a main residence, and its outbuildings.",
          "Automatic exemption up to and including 5 m², and for identical rebuilds after damage.",
          "Swimming pools: around 251 € per m² of pool in 2026. Pergolas, canopies and terraces are not taxable, being neither enclosed nor covered."
        ]
      },
      {
        "type": "paragraph",
        "text": "Since 2022, the details used for the calculation are declared to the tax authorities rather than the town hall, within 90 days of the fiscal completion of the premises, through the “Gérer mes biens immobiliers” section of impots.gouv.fr. Payment is made in a single instalment below 1,500 €. Do not confuse this one-off tax with the annual reassessment of the taxe foncière (property tax): an extension triggers both."
      },
      {
        "type": "subheading",
        "text": "Price per m²: the honest answer"
      },
      {
        "type": "paragraph",
        "text": "No official body publishes a price range per m² for an extension. The figures in circulation come from commercial platforms and contradict each other from one site to the next. What genuinely moves a budget: site access, ground conditions, structural alterations, the construction method and the level of finish. The only reliable figure is a quotation drawn up on a project that has been designed and quantified. Architects' fees are unregulated: no official scale exists."
      },
      {
        "type": "heading",
        "text": "RE2020 and summer comfort: the extension must not degrade the house"
      },
      {
        "type": "paragraph",
        "text": "Since 1 January 2023, RE2020 applies to all extensions to single houses subject to a permit or a déclaration préalable, whatever their surface area. The requirements are graduated: according to the Cerema, a small extension is subject to simple prescriptive requirements (walls, glazing, thermal bridges, ventilation, heating), whereas a large extension moves to the full regulations with a thermal study. An RE2020 certificate must be included with the application."
      },
      {
        "type": "paragraph",
        "text": "The real Mediterranean issue is summer. A heavily glazed south-facing extension with no solar shading turns into a greenhouse from June onwards. Orientation, roof overhang, pergola, thermal mass, night ventilation: these choices are made at sketch stage and cost almost nothing at that point. They are set out in [our guide to Mediterranean bioclimatic architecture](/actualites/architecture-bioclimatique-mediterraneenne-herault)."
      },
      {
        "type": "image",
        "src": "/images/projets/maisonbaillargue/3.webp",
        "alt": "Timber terrace and pergola shading the large south-facing windows of a single-family home built by DP Architecture in Baillargues, Hérault"
      },
      {
        "type": "heading",
        "text": "How the architect supports you, from first sketch to handover"
      },
      {
        "type": "paragraph",
        "text": "Daniela Parito Sorrenti is an architect, a graduate of the Faculty of Architecture and Urban Planning in Rome. She practised for twenty-four years in Paris-based and regional firms before founding her own office in Montpellier in 2014, and she works throughout the Hérault. The practice is an architect's office: it designs the scheme, prepares the planning application and oversees the works. It is not a housebuilder, a general contractor or a seller of turnkey houses."
      },
      {
        "type": "list",
        "items": [
          "**Feasibility**: reading the PLU, the zoning, the easements and the PPRI, to establish what your plot genuinely allows.",
          "**Design**: sketch scheme, then outline and detailed design, relating the extension to the existing house, the light and the orientation.",
          "**Authorisation application**: déclaration préalable or permit, drawings, landscape integration, RE2020 certificate, and liaison with the ABF where the area requires it.",
          "**Tendering**: competitive bidding on a precise set of documents, with quotations compared on a like-for-like basis.",
          "**Site supervision and handover**: visits, checking the work as built, approving interim payments, closing out snags."
        ]
      },
      {
        "type": "paragraph",
        "text": "The first consultation is free. Its purpose is to answer the only question that matters at the outset: is your project feasible, and under which procedure. [Tell us about your extension project](/contact), by telephone on 06 14 90 25 13 or at the practice, 663 rue du Pré aux Clercs in Montpellier."
      }
    ]
  },
  {
    "id": 11,
    "slug": "permis-construire-declaration-prealable-herault",
    "date": "Août 2026",
    "dateEN": "August 2026",
    "dateISO": "2026-08-07",
    "category": "Urbanisme",
    "categoryEN": "Urban Planning",
    "image": "/images/projets/policebaillargue/8.webp",
    "seoTitle": "Permis de construire Hérault : le guide | DP Architecture",
    "seoDescription": "Permis de construire ou déclaration préalable dans l'Hérault : seuils, pièces du dossier, délais, affichage et recours. Le guide complet pour les particuliers.",
    "seoKeywords": "permis de construire Hérault, déclaration préalable travaux, permis de construire Montpellier, extension maison Hérault, architecte permis de construire, seuil 150 m² architecte, délai instruction permis de construire, dossier PCMI maison individuelle",
    "title": "Permis de construire ou déclaration préalable dans l'Hérault",
    "titleEN": "Permis de construire or déclaration préalable in the Hérault",
    "excerpt": "Faut-il un permis de construire ou une déclaration préalable pour votre projet dans l'Hérault ? Seuils de 20, 40 et 150 m², pièces du dossier, délais d'instruction, affichage et recours des tiers : le guide complet pour les particuliers.",
    "excerptEN": "Does your project in the Hérault need a permis de construire (building permit) or a déclaration préalable (prior declaration of works)? Thresholds of 20, 40 and 150 m², the documents required, processing times, site notices and third-party appeals: the complete guide for private clients.",
    "faq": [
      {
        "q": "La mairie ne m'a pas répondu dans le délai : ai-je un permis tacite ?",
        "a": "En principe oui : le silence gardé au terme du délai d'instruction vaut permis tacite ou non-opposition. Mais ce délai n'a couru qu'à compter d'un dossier complet, et une demande de pièces le remet à zéro. Plusieurs situations excluent le permis tacite, notamment un avis défavorable de l'architecte des Bâtiments de France. Demandez à la mairie un certificat attestant l'absence d'opposition avant d'engager le chantier."
      },
      {
        "q": "Dois-je déclarer un mur de clôture de 1,50 m dans mon jardin ?",
        "a": "Le code de l'urbanisme dispense de formalité les murs de moins de 2 mètres, mais pas lorsque le mur constitue une clôture. De nombreuses communes ont soumis les clôtures à déclaration préalable par délibération du conseil municipal, et le PLU encadre souvent hauteur, matériaux et teintes. Vérifiez auprès du service urbanisme de votre commune avant de commander les matériaux."
      },
      {
        "q": "Puis-je construire 145 m² sans architecte, puis agrandir plus tard ?",
        "a": "Le seuil de 150 m² s'apprécie sur la surface de plancher totale après travaux, pas sur la seule surface ajoutée. Une extension de 20 m² sur une maison de 145 m² porte l'ensemble à 165 m² : le recours à un architecte devient obligatoire pour cette seconde demande. Mieux vaut anticiper l'agrandissement dès la conception ; [parlons-en avant l'esquisse](/contact)."
      },
      {
        "q": "Combien coûte le montage d'un dossier de permis de construire ?",
        "a": "Les honoraires d'architecte sont libres : ils dépendent de la nature du projet, de sa surface et de l'étendue de la mission confiée, du seul dossier d'urbanisme jusqu'au suivi de chantier. La première consultation est gratuite et sert à cadrer le projet avant tout engagement. Le détail des prestations figure sur la page [missions](/missions)."
      }
    ],
    "faqEN": [
      {
        "q": "The mairie has not replied within the time limit: do I have a tacit permit?",
        "a": "In principle yes: silence at the end of the processing period amounts to a tacit permit or non-opposition. But that period only started once the file was complete, and any request for missing documents resets it to zero. Several situations rule out a tacit permit, in particular an unfavourable opinion from the architecte des Bâtiments de France. Ask the mairie for a certificate confirming that no objection has been raised before starting work."
      },
      {
        "q": "Do I need to declare a 1.50 m boundary wall in my garden?",
        "a": "The planning code exempts walls under 2 metres from formalities, but not where the wall forms a boundary enclosure. Many municipalities have made fences and boundary walls subject to a déclaration préalable by council resolution, and the PLU often regulates height, materials and colours. Check with your municipality's planning department before ordering materials."
      },
      {
        "q": "Can I build 145 m² without an architect and extend the house later?",
        "a": "The 150 m² threshold is assessed on the total floor area after the works, not on the added area alone. A 20 m² extension to a 145 m² house brings the total to 165 m²: using an architect becomes mandatory for that second application. It is better to plan the extension from the design stage; [let's discuss it before the first sketch](/contact)."
      },
      {
        "q": "How much does preparing a building permit application cost?",
        "a": "Architects' fees are unregulated: they depend on the nature of the project, its floor area and the scope of the brief, from the planning application alone through to site supervision. The first consultation is free and is used to frame the project before any commitment. The range of services is set out on the [missions](/missions) page."
      }
    ],
    "content": [
      {
        "type": "paragraph",
        "text": "Agrandir votre maison, construire une villa, transformer un garage : dans l'Hérault, tout part de la même question. **Permis de construire** ou déclaration préalable ? La réponse tient à deux surfaces réglementaires, à la nature des travaux et au zonage de votre parcelle."
      },
      {
        "type": "heading",
        "text": "Permis de construire ou déclaration préalable : le bon régime"
      },
      {
        "type": "paragraph",
        "text": "L'article R*421-1 du code de l'urbanisme pose le principe : toute construction nouvelle exige un permis, sauf dispense ou soumission à déclaration préalable. Tout se joue ensuite sur l'emprise au sol et la surface de plancher créées, et sur la nature du projet."
      },
      {
        "type": "subheading",
        "text": "Construction neuve isolée : abri, garage, pool house, maison"
      },
      {
        "type": "paragraph",
        "text": "Pour une construction de 12 mètres de hauteur au plus :"
      },
      {
        "type": "list",
        "items": [
          "Jusqu'à 5 m² d'emprise au sol ou de surface de plancher : aucune formalité.",
          "Plus de 5 m² et jusqu'à 20 m² : déclaration préalable.",
          "Au-delà de 20 m² : permis de construire."
        ]
      },
      {
        "type": "paragraph",
        "text": "Régimes particuliers, indépendants de la hauteur :"
      },
      {
        "type": "list",
        "items": [
          "Piscine : bassin non couvert de 10 m² au plus, aucune formalité ; jusqu'à 100 m², non couvert ou couvert sur moins de 1,80 m, déclaration préalable ; au-delà, permis.",
          "Terrasses de plain-pied, châssis et serres de 1,80 m au plus : dispensés.",
          "Murs de moins de 2 m : dispensés, **sauf s'ils constituent une clôture**. De nombreuses communes ont soumis les clôtures à déclaration préalable par délibération du conseil municipal (article R*421-12) : à vérifier en mairie. À partir de 2 m de hauteur, un mur relève de la déclaration préalable."
        ]
      },
      {
        "type": "paragraph",
        "text": "Ces dispenses tombent en site patrimonial remarquable, aux abords d'un monument historique et en site classé : une déclaration préalable y reste exigée."
      },
      {
        "type": "subheading",
        "text": "Extension d'une maison existante : 20 ou 40 m² selon votre zone"
      },
      {
        "type": "paragraph",
        "text": "Le seuil de droit commun est de 20 m² (article R*421-14). Les 40 m² ne valent que pour un bâtiment existant en zone urbaine d'un PLU. Plusieurs communes de l'Hérault relèvent d'une carte communale ou du règlement national d'urbanisme : le seuil y reste 20 m²."
      },
      {
        "type": "paragraph",
        "text": "Second piège, plus coûteux : même en zone U, une extension de 20 à 40 m² repasse en permis si elle porte la surface de plancher totale au-delà de 150 m² — et l'architecte redevient obligatoire. Une maison de 120 m² agrandie de 35 m² atteint 155 m². C'est l'erreur la plus fréquente sur les projets d'[extension de maison à Mauguio](/architecte-mauguio) et autour de Montpellier."
      },
      {
        "type": "subheading",
        "text": "Modification de l'aspect extérieur"
      },
      {
        "type": "paragraph",
        "text": "Créer une ouverture, changer de menuiseries, poser un bardage, refaire une toiture avec un matériau ou une teinte différents, transformer un garage en pièce de vie : déclaration préalable (article R*421-17), sans mètre carré supplémentaire. Seuls l'entretien et la réparation à l'identique y échappent — hors secteur protégé."
      },
      {
        "type": "paragraph",
        "text": "Depuis le 1er mars 2026, le décret n° 2026-117 du 20 février 2026 dispense de formalité la pompe à chaleur en façade non visible depuis l'espace public ou les propriétés voisines — hors abords de monuments historiques, sites patrimoniaux remarquables, sites classés et réserves naturelles, où la déclaration préalable reste due."
      },
      {
        "type": "subheading",
        "text": "Surface de plancher et emprise au sol : deux calculs différents"
      },
      {
        "type": "list",
        "items": [
          "La surface de plancher se mesure à l'intérieur des murs, sous une hauteur supérieure à 1,80 m.",
          "L'emprise au sol est la projection verticale du volume bâti, tous débords et surplombs inclus (article R.420-1) : un carport ouvert de 25 m² ne crée aucune surface de plancher, mais 25 m² d'emprise.",
          "Les seuils s'appliquent à l'une **ou** à l'autre : un projet peut basculer en permis par la seule emprise.",
          "En urbanisme, seules ces deux notions comptent : la « surface habitable » (loi Boutin, DPE) et l'ancienne « SHON », supprimée en 2012, ne calculent aucun seuil de permis."
        ]
      },
      {
        "type": "heading",
        "text": "Architecte obligatoire : le seuil de 150 m² et le cas des SCI"
      },
      {
        "type": "paragraph",
        "text": "La loi du 3 janvier 1977 dispense d'architecte les personnes physiques qui construisent pour elles-mêmes une construction de faible importance. L'article R*431-2 fixe la limite à 150 m² de surface de plancher, usage non agricole : 150 m² pile, pas d'obligation ; 150,5 m², architecte."
      },
      {
        "type": "paragraph",
        "text": "Découverte souvent tardive : la dispense ne vaut que pour les personnes physiques et les exploitations agricoles à responsabilité limitée à associé unique (EARL unipersonnelle). Une SCI, même familiale, est une personne morale : architecte obligatoire quelle que soit la surface. Voir notre [foire aux questions](/faq) et notre article sur la [maison individuelle dans l'Hérault](/actualites/maison-individuelle-herault-architecte-dplg)."
      },
      {
        "type": "heading",
        "text": "Le dossier de permis de construire, pièce par pièce"
      },
      {
        "type": "paragraph",
        "text": "Maison individuelle et annexes : le formulaire diffère selon qu'il s'agit d'un permis ou d'une déclaration préalable, et ses références sont régulièrement remplacées. Le plus sûr est de passer par le téléservice de dépôt en ligne de votre commune, qui présente toujours le formulaire à jour. Le contenu du dossier, lui, est fixé par les articles R*431-7 à R*431-10."
      },
      {
        "type": "list",
        "items": [
          "PCMI1 — plan de situation : le terrain dans la commune.",
          "PCMI2 — plan de masse coté en trois dimensions : travaux extérieurs, plantations, constructions conservées, réseaux.",
          "PCMI3 — plan en coupe : implantation sur le terrain.",
          "PCMI4 — notice descriptive.",
          "PCMI5 — façades et toitures, état initial et futur.",
          "PCMI6 — insertion graphique dans l'environnement bâti et paysager.",
          "PCMI7 et PCMI8 — photographies de l'environnement proche et lointain."
        ]
      },
      {
        "type": "paragraph",
        "text": "Les pièces suivantes dépendent du terrain : lotissement, ZAC, assainissement non collectif, plan de prévention des risques. La liste est limitative : la mairie ne peut réclamer un document non prévu par le code."
      },
      {
        "type": "image",
        "src": "/images/projets/martinet/3.webp",
        "alt": "Plan masse d'un projet : implantation des constructions, accès, stationnement et jardins sur les parcelles"
      },
      {
        "type": "paragraph",
        "text": "Le plan de masse et la notice sont les deux pièces sur lesquelles l'instructeur juge réellement le projet. La notice couvre sept points : l'état initial du terrain et de ses abords — constructions, végétation, éléments paysagers —, puis six partis d'insertion : aménagement du terrain, implantation et volume, traitement des limites, matériaux et couleurs, espaces libres, accès et stationnement."
      },
      {
        "type": "subheading",
        "text": "L'attestation RE2020, souvent mal attribuée"
      },
      {
        "type": "paragraph",
        "text": "En construction neuve, l'attestation de prise en compte des exigences énergétiques et environnementales est jointe au dossier. Au dépôt, elle est établie par le maître d'ouvrage — vous —, avec votre maître d'œuvre le cas échéant. À ne pas confondre avec l'attestation d'achèvement, qui émane d'un professionnel habilité. Voir [la RE2020 dans l'Hérault](/actualites/re2020-herault-architecture-durable)."
      },
      {
        "type": "heading",
        "text": "Délais d'instruction : les durées légales et leurs majorations"
      },
      {
        "type": "paragraph",
        "text": "Le délai court à compter de la réception en mairie d'un dossier **complet**, pas de la date d'envoi."
      },
      {
        "type": "list",
        "items": [
          "Déclaration préalable : 1 mois.",
          "Permis de construire pour une maison individuelle ou ses annexes : 2 mois.",
          "Autres permis de construire et permis d'aménager : 3 mois.",
          "Majoration d'un mois aux abords d'un monument historique, en site patrimonial remarquable ou en cas d'avis de la CDPENAF : en secteur ABF, comptez 3 mois pour un permis de maison, 2 mois pour une déclaration préalable."
        ]
      },
      {
        "type": "paragraph",
        "text": "La demande de pièces manquantes ne suspend pas le délai : elle le remet à zéro. La mairie a un mois pour notifier la liste exhaustive ; passé ce délai, le dossier est réputé complet. Vous avez ensuite trois mois pour fournir les pièces, faute de quoi la demande est rejetée."
      },
      {
        "type": "paragraph",
        "text": "Sans décision expresse dans le délai, le silence vaut permis tacite ou non-opposition. Les exceptions comptent : immeuble ou site classé, enquête publique, évaluation environnementale, et surtout avis défavorable ou assorti de prescriptions de l'architecte des Bâtiments de France. Ne comptez jamais sur un permis tacite en secteur protégé."
      },
      {
        "type": "heading",
        "text": "Dans l'Hérault : PLU, risque inondation, abords protégés"
      },
      {
        "type": "paragraph",
        "text": "Le code fixe la procédure, le PLU fixe le fond : implantation, hauteur, emprise, toiture, couleurs, clôtures, stationnement. Un projet dispensé de formalité doit malgré tout respecter le règlement de zone, souvent plus restrictif. Documents d'urbanisme et servitudes se consultent sur le Géoportail de l'urbanisme et auprès du service urbanisme de la commune."
      },
      {
        "type": "subheading",
        "text": "Zone inondable : une contrainte de cotes, pas une case à cocher"
      },
      {
        "type": "paragraph",
        "text": "Les plans de prévention des risques valent servitude d'utilité publique et sont annexés au PLU. Ils peuvent interdire la construction ou l'assortir de prescriptions : cote de plancher minimale, réduction de vulnérabilité, usage restreint des niveaux bas. Dans l'Hérault, ils se consultent auprès de la DDTM 34 ; les cotes du plan de masse se rattachent au système altimétrique du plan. Ne présumez rien du zonage : il se vérifie parcelle par parcelle, pour une [maison d'architecte à Béziers](/architecte-beziers) comme pour une rénovation dans l'arrière-pays."
      },
      {
        "type": "subheading",
        "text": "Abords protégés : l'avis de l'architecte des Bâtiments de France"
      },
      {
        "type": "image",
        "src": "/images/projets/policebaillargue/2.webp",
        "alt": "Réhabilitation de la Maison Galibert à Baillargues, dans l'Hérault : maison ancienne restaurée en secteur protégé, à proximité du clocher"
      },
      {
        "type": "paragraph",
        "text": "Autour des centres anciens, la covisibilité avec un monument protégé déclenche l'avis de l'architecte des Bâtiments de France : délai allongé, pas de permis tacite si l'avis est défavorable, et un dossier qui justifie matériaux et mises en œuvre. La réhabilitation lourde de la Maison Galibert, à [Baillargues](/architecte-baillargues), s'est menée en secteur protégé, près de l'église fortifiée : enduit à la chaux naturelle en trois couches, tuiles canal d'origine reposées, menuiseries bois. D'autres exemples dans [nos réalisations](/projects)."
      },
      {
        "type": "heading",
        "text": "Après la décision : affichage, recours, validité"
      },
      {
        "type": "paragraph",
        "text": "Dès la notification de l'arrêté, ou dès l'acquisition du permis tacite, affichez sur le terrain un panneau rectangulaire de plus de 80 centimètres, visible depuis la voie publique pendant toute la durée du chantier. Mentions exigées :"
      },
      {
        "type": "list",
        "items": [
          "Nom ou dénomination sociale du bénéficiaire.",
          "Nom de l'architecte auteur du projet.",
          "Date de délivrance, numéro du permis, nature du projet, superficie du terrain.",
          "Adresse de la mairie où consulter le dossier.",
          "Selon le projet : surface de plancher autorisée et hauteur.",
          "Délais et voies de recours."
        ]
      },
      {
        "type": "paragraph",
        "text": "Ce panneau conditionne le recours des tiers : les deux mois courent à compter du premier jour d'une période **continue** de deux mois d'affichage régulier. Sans affichage, ou avec un affichage interrompu, le délai ne court pas et le permis reste attaquable. La preuve vous incombe."
      },
      {
        "type": "paragraph",
        "text": "À ne pas confondre avec le retrait administratif : la mairie ne peut retirer un permis illégal que dans les trois mois suivant la décision. Le permis est périmé si les travaux ne commencent pas dans les trois ans, ou s'ils sont interrompus plus d'un an."
      },
      {
        "type": "paragraph",
        "text": "Deux prorogations d'un an sont possibles, à demander en mairie au moins deux mois avant l'expiration ; le silence gardé deux mois vaut accord. Cas particulier : les permis délivrés entre le 28 mai 2022 et le 28 mai 2024, et encore valides au 27 mai 2025, bénéficient d'une validité de cinq ans, mais ne peuvent pas être prorogés."
      },
      {
        "type": "paragraph",
        "text": "Restent deux formalités : la déclaration d'ouverture de chantier (DOC), exigée pour un permis et non pour une déclaration préalable, puis la déclaration attestant l'achèvement et la conformité des travaux (DAACT). La mairie a trois mois pour contester la conformité, cinq si un récolement s'impose, notamment en secteur PPR."
      },
      {
        "type": "heading",
        "text": "Comment l'architecte vous accompagne sur votre permis de construire"
      },
      {
        "type": "paragraph",
        "text": "Un dossier de permis n'est pas un empilement de plans : c'est une démonstration. Il doit prouver que le projet respecte le règlement de zone, s'insère dans son environnement et que ses cotes sont exactes. C'est ce que couvre la [mission d'architecte](/missions) : zonage et servitudes vérifiés avant l'esquisse, pièces graphiques, échanges avec le service instructeur, suivi jusqu'à l'achèvement."
      },
      {
        "type": "paragraph",
        "text": "Daniela Parito Sorrenti, architecte inscrite à l'Ordre des architectes, exerce à Montpellier et intervient dans tout l'Hérault : maisons neuves, extensions, rénovations, réhabilitations en secteur protégé. Elle a exercé vingt-quatre ans en agences parisiennes et régionales avant de fonder son cabinet à Montpellier en 2014."
      },
      {
        "type": "paragraph",
        "text": "La première consultation est gratuite : elle sert à identifier le régime applicable au vu du PLU et des servitudes de votre parcelle, et à vérifier la faisabilité avant tous frais. La décision finale appartient au service instructeur. [Présentez-nous votre projet](/contact) — commune, parcelle, surfaces existante et souhaitée."
      },
      {
        "type": "paragraph",
        "text": "Article à jour au 7 août 2026. Le décret n° 2026-674 du 27 juillet 2026 modifiera la composition du dossier pour les demandes déposées à compter de fin septembre 2026."
      }
    ],
    "contentEN": [
      {
        "type": "paragraph",
        "text": "Extending your house, building a villa, converting a garage: in the Hérault, it all starts with the same question. **Permis de construire** (building permit) or déclaration préalable (prior declaration of works)? The answer turns on two regulatory floor measurements, on the nature of the works and on the zoning of your plot."
      },
      {
        "type": "heading",
        "text": "Permis de construire or déclaration préalable: choosing the right procedure"
      },
      {
        "type": "paragraph",
        "text": "Article R*421-1 of the code de l'urbanisme (French planning code) sets out the principle: any new construction requires a permit, unless exempt or falling under a déclaration préalable. Everything then turns on the emprise au sol (footprint) and the surface de plancher (floor area) created, and on the nature of the project."
      },
      {
        "type": "subheading",
        "text": "New detached structures: shed, garage, pool house, house"
      },
      {
        "type": "paragraph",
        "text": "For a structure no more than 12 metres high:"
      },
      {
        "type": "list",
        "items": [
          "Up to 5 m² of footprint or floor area: no formalities.",
          "Over 5 m² and up to 20 m²: déclaration préalable.",
          "Above 20 m²: permis de construire."
        ]
      },
      {
        "type": "paragraph",
        "text": "Special regimes, independent of height:"
      },
      {
        "type": "list",
        "items": [
          "Swimming pools: an uncovered pool of 10 m² or less, no formalities; up to 100 m², uncovered or with a cover under 1.80 m, déclaration préalable; beyond that, a permit.",
          "Ground-level terraces, cold frames and greenhouses no more than 1.80 m high: exempt.",
          "Walls under 2 m: exempt, **unless they form a boundary enclosure**. Many municipalities have made boundary walls and fences subject to a déclaration préalable by council resolution (article R*421-12): always check with the mairie. From 2 m in height, a wall requires a déclaration préalable."
        ]
      },
      {
        "type": "paragraph",
        "text": "These exemptions fall away within a site patrimonial remarquable (protected heritage area), in the vicinity of a listed monument, and on a classified site: a déclaration préalable remains mandatory there."
      },
      {
        "type": "subheading",
        "text": "Extending an existing house: 20 or 40 m² depending on your zone"
      },
      {
        "type": "paragraph",
        "text": "The standard threshold is 20 m² (article R*421-14). The 40 m² figure only applies to an existing building in an urban zone under a PLU (plan local d'urbanisme, the local planning scheme). Several municipalities in the Hérault are covered by a carte communale or by the national planning rules: there, the threshold remains 20 m²."
      },
      {
        "type": "paragraph",
        "text": "The second pitfall is more expensive: even in a U zone, an extension of 20 to 40 m² reverts to a permit if it takes the total floor area beyond 150 m² — and an architect becomes mandatory again. A 120 m² house extended by 35 m² reaches 155 m². This is the most common mistake on [house extension projects in Mauguio](/architecte-mauguio) and around Montpellier."
      },
      {
        "type": "subheading",
        "text": "Changes to the external appearance"
      },
      {
        "type": "paragraph",
        "text": "Creating an opening, replacing windows and doors, fitting cladding, re-roofing with a different material or colour, converting a garage into living space: a déclaration préalable is required (article R*421-17), with no square metre added. Only maintenance and like-for-like repair escape it — outside protected areas."
      },
      {
        "type": "paragraph",
        "text": "Since 1 March 2026, decree no. 2026-117 of 20 February 2026 has exempted from formalities a heat pump on a façade not visible from public space or neighbouring properties — except near listed monuments, in sites patrimoniaux remarquables, on classified sites and in nature reserves, where a déclaration préalable is still required."
      },
      {
        "type": "subheading",
        "text": "Surface de plancher and emprise au sol: two different calculations"
      },
      {
        "type": "list",
        "items": [
          "The surface de plancher is measured inside the walls, under a ceiling height greater than 1.80 m.",
          "The emprise au sol is the vertical projection of the built volume, all overhangs and projections included (article R.420-1): an open carport of 25 m² creates no floor area, but 25 m² of footprint.",
          "The thresholds apply to one **or** the other: a project can tip into permit territory on footprint alone.",
          "In planning law, only these two definitions count: \"habitable area\" (loi Boutin, energy performance certificates) and the former \"SHON\", abolished in 2012, calculate no permit threshold."
        ]
      },
      {
        "type": "heading",
        "text": "When an architect is mandatory: the 150 m² threshold and the SCI case"
      },
      {
        "type": "paragraph",
        "text": "The law of 3 January 1977 exempts from using an architect those natural persons who build a structure of modest size for their own use. Article R*431-2 sets the limit at 150 m² of floor area, for non-agricultural use: exactly 150 m², no obligation; 150.5 m², architect required."
      },
      {
        "type": "paragraph",
        "text": "Often discovered too late: the exemption applies only to natural persons and to single-member limited-liability agricultural holdings (EARL unipersonnelle). An SCI (société civile immobilière, a property-holding company), even a family one, is a legal entity: an architect is mandatory whatever the floor area. See our [frequently asked questions](/faq) and our article on [detached houses in the Hérault](/actualites/maison-individuelle-herault-architecte-dplg)."
      },
      {
        "type": "heading",
        "text": "The permis de construire file, document by document"
      },
      {
        "type": "paragraph",
        "text": "Detached house and outbuildings: the form differs depending on whether you are applying for a permit or a déclaration préalable, and its reference is regularly superseded. The safest route is your commune's online filing service, which always shows the current form. The contents of the file are set by articles R*431-7 to R*431-10."
      },
      {
        "type": "list",
        "items": [
          "PCMI1 — location plan: the site within the municipality.",
          "PCMI2 — dimensioned block plan in three dimensions: external works, planting, retained buildings, utilities.",
          "PCMI3 — section drawing: siting on the site.",
          "PCMI4 — descriptive statement.",
          "PCMI5 — elevations and roofs, existing and proposed.",
          "PCMI6 — graphic integration into the built and landscape setting.",
          "PCMI7 and PCMI8 — photographs of the immediate and wider surroundings."
        ]
      },
      {
        "type": "paragraph",
        "text": "The remaining documents depend on the site: housing estate, ZAC, off-mains drainage, risk prevention plan. The list is exhaustive: the mairie cannot demand a document not provided for by the code."
      },
      {
        "type": "image",
        "src": "/images/projets/martinet/3.webp",
        "alt": "Site layout plan: positioning of buildings, access, parking and gardens across the plots"
      },
      {
        "type": "paragraph",
        "text": "The block plan and the descriptive statement are the two documents on which the case officer genuinely assesses the project. The statement covers seven points: the initial state of the site and its surroundings — buildings, vegetation, landscape features —, then six design choices: treatment of the site, siting and massing, treatment of boundaries, materials and colours, open space, access and parking."
      },
      {
        "type": "subheading",
        "text": "The RE2020 certificate, often assigned to the wrong party"
      },
      {
        "type": "paragraph",
        "text": "For new build, the certificate confirming that energy and environmental requirements have been taken into account is attached to the file. At submission stage it is drawn up by the maître d'ouvrage (client) — you —, with your maître d'œuvre where appropriate. Do not confuse it with the completion certificate, which comes from an accredited professional. See [RE2020 in the Hérault](/actualites/re2020-herault-architecture-durable)."
      },
      {
        "type": "heading",
        "text": "Processing times: the statutory periods and their extensions"
      },
      {
        "type": "paragraph",
        "text": "The clock starts when the mairie receives a **complete** file, not on the date you send it."
      },
      {
        "type": "list",
        "items": [
          "Déclaration préalable: 1 month.",
          "Permis de construire for a detached house or its outbuildings: 2 months.",
          "Other building permits and development permits: 3 months.",
          "One extra month near a listed monument, within a site patrimonial remarquable, or where the CDPENAF must give an opinion: in an ABF-controlled area, allow 3 months for a house permit and 2 months for a déclaration préalable."
        ]
      },
      {
        "type": "paragraph",
        "text": "A request for missing documents does not suspend the clock: it resets it to zero. The mairie has one month to notify the exhaustive list; after that month, the file is deemed complete. You then have three months to supply the documents, failing which the application is refused."
      },
      {
        "type": "paragraph",
        "text": "Where no express decision is issued within the time limit, silence amounts to tacit consent or non-opposition. The exceptions matter: listed buildings or sites, public inquiry, environmental assessment, and above all an unfavourable opinion — or one subject to conditions — from the architecte des Bâtiments de France. Never count on a tacit permit in a protected area."
      },
      {
        "type": "heading",
        "text": "In the Hérault: PLU, flood risk, protected settings"
      },
      {
        "type": "paragraph",
        "text": "The code sets the procedure, the PLU sets the substance: siting, height, footprint, roofing, colours, boundary walls, parking. A project exempt from formalities must still comply with the zone regulations, often more restrictive. Planning documents and easements can be consulted on the Géoportail de l'urbanisme and with the municipality's planning department."
      },
      {
        "type": "subheading",
        "text": "Flood zones: a matter of levels, not a tick box"
      },
      {
        "type": "paragraph",
        "text": "Risk prevention plans have the force of a public utility easement and are appended to the PLU. They may prohibit building or attach conditions to it: minimum floor level, vulnerability reduction, restricted use of lower storeys. In the Hérault, they can be consulted at the DDTM 34; the levels on the block plan are tied to that plan's altimetric datum. Take nothing for granted about zoning: it must be checked plot by plot, for an [architect-designed house in Béziers](/architecte-beziers) as for a renovation in the hinterland."
      },
      {
        "type": "subheading",
        "text": "Protected settings: the opinion of the architecte des Bâtiments de France"
      },
      {
        "type": "image",
        "src": "/images/projets/policebaillargue/2.webp",
        "alt": "The Maison Galibert in Baillargues, Hérault: a period house restored in a protected area near the church tower"
      },
      {
        "type": "paragraph",
        "text": "Around historic centres, intervisibility with a protected monument triggers the opinion of the architecte des Bâtiments de France: a longer processing time, no tacit permit if the opinion is unfavourable, and a file that justifies materials and construction details. The major restoration of Maison Galibert in [Baillargues](/architecte-baillargues) was carried out in a protected area, near the fortified church: three-coat natural lime render, original canal tiles relaid, timber joinery. Further examples in [our projects](/projects)."
      },
      {
        "type": "heading",
        "text": "After the decision: site notice, appeals, validity"
      },
      {
        "type": "paragraph",
        "text": "As soon as the decision is notified, or as soon as a tacit permit is acquired, display on the site a rectangular board more than 80 centimetres wide, visible from the public highway throughout the works. Required information:"
      },
      {
        "type": "list",
        "items": [
          "Name or company name of the permit holder.",
          "Name of the architect who designed the project.",
          "Date of issue, permit number, nature of the project, site area.",
          "Address of the mairie where the file may be consulted.",
          "Depending on the project: authorised floor area and height.",
          "Time limits and routes of appeal."
        ]
      },
      {
        "type": "paragraph",
        "text": "This board governs third-party appeals: the two months run from the first day of an **uninterrupted** two-month period of proper display. Without a notice, or with interrupted display, the period does not start and the permit remains open to challenge. The burden of proof falls on you."
      },
      {
        "type": "paragraph",
        "text": "Do not confuse this with administrative withdrawal: the mairie can only withdraw an unlawful permit within three months of the decision. The permit lapses if works do not start within three years, or if they are interrupted for more than a year."
      },
      {
        "type": "paragraph",
        "text": "Two one-year extensions are possible, to be requested from the mairie at least two months before expiry; silence for two months amounts to approval. Special case: permits issued between 28 May 2022 and 28 May 2024 and still valid on 27 May 2025 have a five-year validity, but cannot be prolonged."
      },
      {
        "type": "paragraph",
        "text": "Two formalities remain: the déclaration d'ouverture de chantier (notice of commencement of works), required for a permit but not for a déclaration préalable, then the déclaration attestant l'achèvement et la conformité des travaux (statement of completion and compliance). The mairie has three months to challenge compliance, five where an inspection is required, notably in a PPR area."
      },
      {
        "type": "heading",
        "text": "How an architect supports you through your permis de construire"
      },
      {
        "type": "paragraph",
        "text": "A permit file is not a stack of drawings: it is an argument. It must show that the project complies with the zone regulations, sits well in its surroundings and that its dimensions are accurate. That is what the [architect's brief](/missions) covers: zoning and easements checked before the first sketch, graphic documents, dealings with the case officer, follow-through to completion."
      },
      {
        "type": "paragraph",
        "text": "Daniela Parito Sorrenti, an architect registered with the Ordre des architectes, practises in Montpellier and works throughout the Hérault: new houses, extensions, renovations, restorations in protected areas. She practised for twenty-four years in Paris-based and regional firms before founding her office in Montpellier in 2014."
      },
      {
        "type": "paragraph",
        "text": "The first consultation is free: it serves to identify the applicable procedure in the light of the PLU and the easements on your plot, and to check feasibility before any expenditure. The final decision rests with the planning department. [Tell us about your project](/contact) — municipality, plot, existing and desired areas."
      },
      {
        "type": "paragraph",
        "text": "Article up to date as at 7 August 2026. Decree no. 2026-674 of 27 July 2026 will change the contents of the application file for applications submitted from late September 2026."
      }
    ]
  }
];

export default articlesData;
